/*jshint esversion: 9 */

/*
// jQuery: initSearchFilterControls
// Search Filter Controls is used to handle navigation of the Search Results process
*/

jQuery(function initSearchFilterControls($) {

    $('.search-filter-controls').each(function(index, el) {

        var $siteBodyContainer            = $(document.body);
        var $container                    = $(this);
        var $mobileContainer              = $('.js-mobile-search');
        var $mobileMenuOverlay            = $('#js-btn-mobile-menu-close-overlay');
        var searchType                    = $('.js-search-type').val();

        var $staticContentContainer       = $('.hybrid-search-static-content-container');
        var $hybridSearchContainer        = $('.hybrid-search-container');
        var $searchResultsContainer       = $('.search-results');
        var $hybridListContainer          = $('.hybrid-list-results');
        var $hybridMapContainer           = $('.hybrid-map-results');

        var $searchHeader                 = $container.find('.js-search-header');
        var $primaryControlsContainer     = $container.find('.js-primary-controls');
        var $secondaryControlsContainer   = $siteBodyContainer.find('.js-secondary-controls');
        var $destinationFilterControls    = $container.find('.destination-filter-controls');
        var $secondaryFilterControls      = $container.find('.secondary-filter-controls');
        var $primaryFilterSets            = $container.find('.js-primary-filter-container');
        var $secondaryFilterSets          = $container.find('.js-filter-container');
        var $buttonControls               = $siteBodyContainer.find('.js-button-control');
        var $closeButtons                 = $container.find('.close-filters-btn');
        var $filterSections               = $container.find('.js-filter-section');

        var $desktopDateRangePicker       = $('.btn-travel-dates-primary');
        var $mobileDateRangePicker        = $('.btn-travel-dates-mobile');
        var $startDateControl             = $container.find('.js-date-start');
        var $endDateControl               = $container.find('.js-date-end');
        var $desktopDateRangePickerLabel  = $desktopDateRangePicker.find('.js-travel-dates-label');
        var $mobileDateRangePickerLabel   = $mobileDateRangePicker.find('.js-travel-dates-label');

        var historyStateLog               = {};
        var isTransitioning               = false;
        var animationParameters           = {duration: 500, queue: false};
        var travelByDays                  = maxTravelByDays;
        var lastCompleteURL               = location.pathname;
        var listScrollingEnabled          = true;
        var disableTracking               = disableTrackingCode;
        var localeLanguage                = 'en';

        var resetScrollPosition           = false;
        var lastScrollCard                = '';
        var lastFieldName                 = '';

        // ****************************************************
        // Type Ahead Configuration
        // ****************************************************

        var lastTypeAhead                 = '';
        var typeAheadData                 = destinationSearchData;
        var typeAheadHistory              = Cookies.get('afvcSearchHistory');

        var intro                         = '';
        var tourInitialized               = false;

        if (typeof typeAheadHistory !== 'undefined' && typeAheadHistory !== '') {

            typeAheadHistory = typeAheadHistory.split(',');
        }
        else {

            typeAheadHistory = [];
        }

        var appliedStartDate              = $startDateControl.val();
        var appliedEndDate                = $endDateControl.val();
        var previousStartDate             = '';
        var previousEndDate               = '';

        if (searchType === 'search-results') {

            var $sortFilter               = $container.find('.sort-filter');
            var currentResortPage         = initialFilters.filters.page;
            var currentResortCount        = $('.initial-resort-count').val();
            var resortsPerPage            = systemResultsPerPage;
            var currentShowingCount       = (currentResortCount < resortsPerPage) ? currentResortCount : resortsPerPage;

            // ****************************************************
            // Google Map Variables
            // Important Note - The "markers" variable must be an object, not an array, so we can use ResortID values as indexes
            // ****************************************************

            var usingDefaultMap           = false;
            var map                       = '';
            var bounds                    = '';
            var markers                   = {};
            var mapInitialized            = false;
            var lastValidCenter           = '';
            var minZoomLevel              = 5;
            var minSearchAreaZoomLevel    = 5;
            var mapEnableSwitch           = mapEnableSwitchOverride;
            var smoothZoomControl         = '';
            var mapLocatorEnabled         = mapLocatorSwitch;
            var lastInfoBoxResort         = '';
            var infoBox;

            // ****************************************************
            // If the kill switch for google maps (mapEnableSwitch) is set to false, this means we are intentionally disabling use of the google map
            // Hide the map container from view and ensure that the list card area takes up the full width of the page
            // ****************************************************

            if (!mapEnableSwitch) {

                $hybridMapContainer.hide();
                $hybridListContainer.addClass('map-disabled-mode');
            }

            var googleMapData = '';

            if (typeof mapData === 'object') {

                googleMapData = mapData;
            }

            // ****************************************************
            // Featured Search Content
            // ****************************************************

            var $featuredSearchContent = $('.featured-search-content');
            var currentFeatureType     = '';
            var currentFeatureURLKey   = '';

            if ($('.js-featured-content').length) {

                currentFeatureURLKey = $('.js-featured-content').data('feature-urlkey');
                currentFeatureType   = $('.js-featured-content').data('feature-type');
            }
            else {

                $featuredSearchContent.hide();
                $('.site-container-search').addClass('additional-padding-scenario');
            }

            // ****************************************************
            // Search Throttle Variables
            // ****************************************************
            var isSearchThrottled        = false;
            var throttleDelayFrom        = 0;
            var throttleDelayTo          = 0;
            var enablePerformanceMetrics = enableMetrics;
        }

        // ****************************************************
        // Screen width / responsive mode check
        // ****************************************************

        var screenMode = ($( window ).width() <= 767) ? 'responsive' : 'standard';

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             INITIALIZING FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    initializeComponents
        // PARAMETERS:  none
        // DESCRIPTION: This function handles triggering of all appropriate major component initializers for the search process
        // **************************************************************************************************************
        var initializeComponents = function() {

            if (searchType !== 'search-results') {

                if (performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD) {

                    // When reloading the homepage via the "Back" or "Forward" buttons, reload the page
                    // This resolves an issue where the last input that was selected will still be "selected" from a click event standpoint

                    window.location.reload();
                }
            }

            // The order of initialization for each function matters and must be done in the proper sequence

            if (searchType === 'search-results') {

                initializeMapType();
                initializeViewMode();
            }

            initializeMobileSearch();

            if (searchType === 'search-results') {

                initializeHistoryStateLog();
                updateSearchThrottle(searchThrottle.config);
                displayPerformanceMetrics(performanceMetrics.data);

                if (mapEnableSwitch) {

                    // Check every 250ms if the google map has finished loading
                    // After it has loaded, we can initialize the remainder of the interface controls

                    intervalCheck = setInterval(mapApiLoadCheck, 250);
                }
                else {

                    // We are not using the google map, so we need to trigger several control loaders that normally
                    // depend first on the google map finishing its initialization process

                    initializeControls();
                    loadTourControls();
                }
            }
            else {

                initializeControls();
                initializeSaleControls();
            }

            initializeObservers();
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeMapType
        // PARAMETERS:  none
        // DESCRIPTION: This function handles determining if default Google Map (e.g. map markers) should be used
        // **************************************************************************************************************
        var initializeMapType = function() {

            var ua = window.navigator.userAgent;

            if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {

                // IE 10 or older OR IE 11 OR Edge (IE 12)+

                usingDefaultMap = true;
            }
        }

        // **************************************************************************************************************
        // FUNCTION:    initializeViewMode
        // PARAMETERS:  none
        // DESCRIPTION: This function handles hiding and showing the appropriate initial view containers
        // **************************************************************************************************************
        var initializeViewMode = function() {

            if ($('.resort-block-set').length) {

                $staticContentContainer.hide();
                $hybridSearchContainer.show();
            }
            else {

                $hybridSearchContainer.hide();
                $staticContentContainer.show();
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeMobileSearch
        // PARAMETERS:  none
        // DESCRIPTION: This function handles moving the mobile search elements to the appropriate part of the dom. This is done at the time of initialization to allow
        //              the scrubbing functionality etag to only be run once for all initial filter segments, even though the HTML for the mobile search needs to live
        //              outside of and separately from the rest of the filter controls in the main template structure (to allow for the mobile responsive interface to work)
        // **************************************************************************************************************
        var initializeMobileSearch = function() {

            var $htmlSource      = $mobileContainer;
            var $htmlDestination = $('#js-mobile-menu-content');
            var $htmlContent     = $htmlSource.detach();
            $htmlDestination.append($htmlContent);
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeHistoryStateLog
        // PARAMETERS:  none
        // DESCRIPTION: This function handles the inital popstate event that the browser triggers upon page load. First, it replaces the state in the browser history API
        //              so that we have a valid event history for this first page. Then, we build out the history log entry (which is used for caching our search data in
        //              the javascript layer to be used for history api reverts of the page content) with existing elements from the loaded page. The "initialFilters.filters"
        //              is a javascript variable that is manually loaded via an etag on page load, and contains the filters object of arrays that is needed for this history entry
        // **************************************************************************************************************
        var initializeHistoryStateLog = function() {

            history.replaceState({id: location.pathname}, '', location.pathname + location.search);
            historyObject = {'type': '', 'results': '', 'mapData': '', 'currentPage': '', 'resortCount': '', 'filters': '', 'featuredType': '', 'featuredURLKey': '', 'featuredContent': '', 'metaTitle': '', 'metaDescription': '', 'metaCatalogueTag': ''};

            if ($('.resort-block-set').length) {

                historyObject.type    = 'list';
                historyObject.results = $searchResultsContainer.html().trim();
                historyObject.mapData = googleMapData;
            }
            else {

                historyObject.type    = 'static';
                historyObject.results = $staticContentContainer.html().trim();
                historyObject.mapData = '';
            }

            var catalogueTag;

            if ($('link[rel="canonical"]').length) {

                catalogueTag = $('link[rel="canonical"]');
            }
            else {

                catalogueTag = $('meta[name=robots]');
            }

            historyObject.currentPage          = initialFilters.filters.page;
            historyObject.filters              = initialFilters.filters;
            historyObject.resortCount          = currentResortCount;
            historyObject.featuredType         = currentFeatureType;
            historyObject.featuredURLKey       = currentFeatureURLKey;
            historyObject.featuredContent      = $featuredSearchContent.html().trim();
            historyObject.metaTitle            = $('title');
            historyObject.metaDescription      = $('meta[name=description]');
            historyObject.metaCatalogueTag     = catalogueTag;
            historyStateLog[location.pathname] = historyObject;
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeMapView
        // PARAMETERS:  none
        // DESCRIPTION: This function handles instantiating / loading / re-loading the google map (Map View) whenever the user toggles between views, or performs
        //              a faceted search in map view and needs to load new marker content into the map
        // **************************************************************************************************************
        var initializeMapView = function() {

            // If we have initial Map Data (which only occurs on a Map View initial page load or when switching to Map View via the faceted search process)
            // We also only want to initialize the map once, so we check the "mapInitialized" variable

            if (mapEnableSwitch) {

                if (googleMapData !== '' && !mapInitialized) {

                    mapInitialized = true;
                    getMapConfiguration();
                }
                else if (googleMapData !== '') {

                    loadMapMarkers();
                }
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles setting up the event handlers for all of the Search Process Interface Controls
        // **************************************************************************************************************
        var initializeControls = function() {

            loadDestinationControls();
            loadDatePickers();
            loadSecondaryControls();
            loadMobileControls();
            loadCustomControls();
            loadErrorControls();

            if (searchType === 'search-results') {

                // Initialize the View More secondary control
                updateResortCount(currentResortCount);
                updateBackToTopControl();

                // Enable the "See Available Dates" event click handlers
                createListCardEvents();

                $('.search-filter-controls').find('.js-scroller').each(function(el) {

                    $(this).scrollLock();
                });

                // Enable the stickyfill polyfill for all sticky positioned elements
                Stickyfill.add($('.sticky-polyfill-item'));

                // Enable the lazy loader library to start loading resort images
                lazyLoadImages();

                // Initialize the starting state of the destinations type ahead input label
                updateDestinationDisplay();

                // Initialize the featured content disclaimers dialog
                configureFeaturedInfoDialogs();
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    initializePostMapLoadItems
        // PARAMETERS:  none
        // DESCRIPTION: This function handles setting up all functionality that must be triggered after the google map has finished loading completely
        // **************************************************************************************************************
        var initializePostMapLoadItems = function() {

            // Refresh the "Search This Area" button after the map has finished initializng
            refreshSearchAreaButton();

            // Once the map has finished loading, the tour can then be loaded properly (because it uses the map for several steps)
            loadTourControls();
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeObservers
        // PARAMETERS:  none
        // DESCRIPTION: This function handles observing when the daterangepicker overlay is activated (for mobile interface purposes)
        //              by looking at the body tag and seeing if it has an activated class. We can then modify the z-index of the
        //              main search interface accordingly to allow both itself and the main navigation to properly account for one another
        // **************************************************************************************************************
        var initializeObservers = function() {

            const targetElement = document.body;

            const observer = new MutationObserver(function(mutationsList) {

                mutationsList.forEach(function(mutation) {

                    if (mutation.attributeName === 'class') {

                        if ($(targetElement).hasClass('date-range-picker-active')) {

                            $('.search-filter-controls').css('z-index', 5);
                        }
                        else {
                            $('.search-filter-controls').css('z-index', 3);
                        }
                    }
                });
            });

            observer.observe(targetElement, {
                attributes: true,
                attributeFilter: ['class']
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    initializeSaleControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles homepage specific sale controls such as viewing the currently active sales
        // **************************************************************************************************************
        var initializeSaleControls = function() {

			$('.js-see-current-sales').click(function() {

		        $('html, body').animate({
		            scrollTop: $('.home-top-deals').offset().top
		        }, 300);
			});
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             CONTROL CONFIGURATIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    loadDestinationControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles setting up the "Destinations" related event handlers for all of the Search Process Interface Controls
        // **************************************************************************************************************
        var loadDestinationControls = function() {

            // **************************************************************************************************************
            // Desktop - Destinations [Type Ahead] [Button Click] Control
            // **************************************************************************************************************
            $('.js-destination-type-ahead').click(function(e) {

                // Ensure we stop click propagation from moving up further and hitting the click management
                // event that exists on the <html> DOM element of the page. Instead, manage all click related
                // events locally in this specific click event handler

                e.stopPropagation();

                if (openTypeAheadModal()) {

                    // After opening the modal (only if it was previously un-opened), run an initial search to properly populate the search criteria results

                    var currentValue = $('.js-destination-type-ahead').val().toLowerCase();
                    performTypeAheadSearch(currentValue);
                }
            });

            // **************************************************************************************************************
            // Desktop - Destinations [Type Ahead] [Key Press] Control
            // **************************************************************************************************************
            $('.js-destination-type-ahead').on('keyup', function(e) {

                var currentValue  = $('.js-destination-type-ahead').val().toLowerCase();

                if (lastTypeAhead !== currentValue) {

                    lastTypeAhead = currentValue;
                    openTypeAheadModal();
                    performTypeAheadSearch(currentValue);
                }
            });

            // **************************************************************************************************************
            // Desktop - Destinations [Legacy] Menu Control
            // **************************************************************************************************************
            $('.js-legacy-destination-toggle').click(function(e) { toggleFilter(e, $('.btn-destination-primary'), $('.primary-destination-filters')); });
            $('.js-legacy-destination-alternate-toggle').click(function(e) { toggleFilter(e, $('.btn-destination-primary'), $('.primary-destination-filters')); });

            // **************************************************************************************************************
            // Desktop - Destinations [Region] Controls
            // **************************************************************************************************************
            $container.find('.js-region-control').each(function() {

                $(this).click(function() {

                    if (!$(this).hasClass('disabled-selector')) {

                        if ($(this).hasClass('sub-region-open') || !$(this).hasClass('region-open')) {

                            var regionID              = $(this).data('region-id');
                            var targetRegionContainer = $container.find('.js-region-container[data-region-id="' + regionID + '"]');
                            var singularSubRegion     = targetRegionContainer.data('singular-sub-region');

                            $container.find('.js-region-control').removeClass('region-open sub-region-open');
                            $(this).addClass('region-open');
                            $container.find('.js-region-container').hide();
                            $container.find('.js-sub-region-container').hide();

                            if (singularSubRegion === 'NA') {

                                targetRegionContainer.show();
                            }
                            else {

                                $container.find('.js-sub-region-container[data-sub-region-id="' + singularSubRegion + '"]').show();
                            }
                        }
                    }
                });
            });

            // **************************************************************************************************************
            // Desktop - Destinations [Sub-Region] Controls
            // **************************************************************************************************************
            $container.find('.js-sub-region-control').each(function() {

                $(this).click(function() {

                    if (!$(this).hasClass('disabled-selector')) {

                        var regionID    = $(this).closest('.js-region-container').data('region-id');
                        var subRegionID = $(this).data('sub-region-id');

                        $container.find('.js-region-control').removeClass('region-open sub-region-open');
                        $container.find('.js-region-control[data-region-id="' + regionID + '"]').addClass('sub-region-open');
                        $container.find('.js-region-container').hide();
                        $container.find('.js-sub-region-container').hide();
                        $container.find('.js-sub-region-container[data-sub-region-id="' + subRegionID + '"]').show();
                    }
                });
            });

            // **************************************************************************************************************
            // Desktop - Destinations [Checkbox] Controls
            // **************************************************************************************************************
            $('.primary-destination-filters').find('.js-destination-checkbox .js-filter-checkbox').each(function(el) {

                $(this).click(function(e) {

                    if (!isTransitioning) {

                        isTransitioning = true;

                        // Determine if we are unchecking a selection that may cause a zero result search due to other disabled selections in the same category
                        checkDisabledSelections($(this), $('.primary-destination-filters'));

                        // Update the state of the appropriate Check All button for this sub-region
                        var subRegionCheckAllButton = $(this).closest('.js-sub-region-container').find('.js-check-all');
                        updateCheckSubRegionButton(subRegionCheckAllButton);

                        // Update the state of the appropriate Check All button for this region
                        var regionID             = $(this).closest('.js-sub-region-container').data('region-id');
                        var regionCheckAllButton = $container.find('.js-region-container[data-region-id="' + regionID + '"]').find('.js-check-all')
                        updateCheckRegionButton(regionCheckAllButton);

                        updateDestinationControls($(this));

                        if (checkDestinationFilters()) {

                            $('.btn-destination').addClass('selected');
                            toggleResetButton('destinations', 'on');
                        }
                        else {

                            toggleResetButton('destinations', 'off');
                        }

                        performFacetedSearch($(this).attr('name'));
                    }
                    else {

                        e.preventDefault();
                    }
                });
            });

            // **************************************************************************************************************
            // Desktop - Destinations [Check All] Controls
            // **************************************************************************************************************
            $('.primary-destination-filters').find('.js-check-all').each(function(el) {

                $(this).click(function(e) {

                    if (!isTransitioning) {

                        var buttonType     = $(this).data('button-type');
                        var regionCheckAll = (buttonType === 'region') ? true : false;
                        var regionID       = '';

                        if (regionCheckAll) {

                            // Region specific Check-All button

                            var regionContainer     = $(this).closest('.js-region-container');
                            regionID                = regionContainer.data('region-id');
                            var subRegionContainers = $container.find('.js-sub-region-container[data-region-id="' + regionID + '"]');

                            // Ensure that this region has at least one enabled option to check, meaning we won't force a zero result
                            if (checkAvailableFilterSelections(subRegionContainers)) {

                                isTransitioning = true;

                                // Check to see if there are any applicable filters that can be checked by hitting this button
                                if (!checkAllFilterSelections(subRegionContainers)) {

                                    // Options are available to check for this region, so we need to check all options
                                    subRegionContainers.find('.js-destination-checkbox .js-filter-checkbox').each(function() {

                                        $(this).prop("checked", true);
                                    });
                                }
                                else {

                                    // All options are already checked, so hitting this button should instead un-check all options
                                    subRegionContainers.find('.js-destination-checkbox .js-filter-checkbox').each(function() {

                                        $(this).prop("checked", false);
                                    });

                                    // Determine if we are unchecking a selection that may cause a zero result search due to other disabled selections in the same category
                                    checkDisabledSelections(subRegionContainers.find('.js-destination-checkbox .js-filter-checkbox').first(), $('.primary-destination-filters'));
                                }

                                // Update the state of the appropriate Check All button for this region
                                updateCheckRegionButton($(this));

                                // Update the state of all of this region's sub-region specific Check All buttons
                                $container.find('.js-sub-region-container[data-region-id="' + regionID + '"]').find('.js-check-all').each(function() {

                                    updateCheckSubRegionButton($(this));
                                });

                                updateDestinationControls($(this));

                                if (checkDestinationFilters()) {

                                    $('.btn-destination').addClass('selected');
                                    toggleResetButton('destinations', 'on');
                                }
                                else {

                                    toggleResetButton('destinations', 'off');
                                }

                                performFacetedSearch('check-all');
                            }
                            else {

                                e.preventDefault();
                            }
                        }
                        else {

                            // Sub-Region specific Check-All button

                            var subRegionContainer = $(this).closest('.js-sub-region-container');

                            // Ensure that this sub region has at least one enabled option to check, meaning we won't force a zero result
                            if (checkAvailableFilterSelections(subRegionContainer)) {

                                isTransitioning = true;

                                // Check to see if there are any applicable filters that can be checked by hitting this button
                                if (!checkAllFilterSelections(subRegionContainer)) {

                                    // Options are available to check for this sub region block, so we need to check all options
                                    subRegionContainer.find('.js-destination-checkbox .js-filter-checkbox').each(function() {

                                        $(this).prop("checked", true);
                                    });
                                }
                                else {

                                    // All options are already checked, so hitting this button should instead un-check all options
                                    subRegionContainer.find('.js-destination-checkbox .js-filter-checkbox').each(function() {

                                        $(this).prop("checked", false);
                                    });

                                    // Determine if we are unchecking a selection that may cause a zero result search due to other disabled selections in the same category
                                    checkDisabledSelections(subRegionContainer.find('.js-destination-checkbox .js-filter-checkbox').first(), $('.primary-destination-filters'));
                                }

                                // Update the state of the appropriate Check All button for this sub-region
                                updateCheckSubRegionButton($(this));

                                // Update the state of the appropriate Check All button for this region
                                regionID                 = $(this).closest('.js-sub-region-container').data('region-id');
                                var regionCheckAllButton = $container.find('.js-region-container[data-region-id="' + regionID + '"]').find('.js-check-all')
                                updateCheckRegionButton(regionCheckAllButton);

                                updateDestinationControls($(this));

                                if (checkDestinationFilters()) {

                                    $('.btn-destination').addClass('selected');
                                    toggleResetButton('destinations', 'on');
                                }
                                else {

                                    toggleResetButton('destinations', 'off');
                                }

                                performFacetedSearch('check-all');
                            }
                            else {

                                e.preventDefault();
                            }
                        }
                    }
                    else {

                        e.preventDefault();
                    }
                });
            });

            // **************************************************************************************************************
            // Global - Destinations [Reset Filters] Control
            // **************************************************************************************************************
            $('.js-reset-destinations').click(function() {

                if (!isTransitioning) {

                    isTransitioning = true;
                    clearDestinationFilters(true);
                }
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    loadDatePickers
        // PARAMETERS:  none
        // DESCRIPTION: This function handles initializing the date range picker controls
        // **************************************************************************************************************
        var loadDatePickers = function() {

            moment.locale(localeLanguage);

            var dateRangePickerLocaleConfig = getLocaleConfiguration(localeLanguage);

            // Initialize and detach the desktop date-picker

            $desktopDateRangePicker.daterangepicker({
                opens: 'center',
                minDate: moment(),
                maxDate: moment().add(travelByDays, 'days'),
                locale: dateRangePickerLocaleConfig
            });

            $desktopDateRangePicker.on('apply.daterangepicker', function(ev, picker) {

                applyTravelDates('desktop', picker);
            });

            $desktopDateRangePicker.on('cancel.daterangepicker', function(ev, picker) {

                clearTravelDates(true);
            });

            $desktopDateRangePicker.on('show.daterangepicker', function(ev, picker) {

                $primaryFilterSets.each(function(el) {

                    if ($(this).is(':visible')) { $(this).hide(); }
                });

                toggleButton($desktopDateRangePicker, 'on');

                $('body').removeClass('date-range-picker-active');
            });

            $desktopDateRangePicker.on('hide.daterangepicker', function(ev, picker) {

                $desktopDateRangePicker.removeClass('current');

                $('body').removeClass('date-range-picker-active');
            });

            if (appliedStartDate !== '' && appliedEndDate !== '') {

                $desktopDateRangePicker.data('daterangepicker').setStartDate(appliedStartDate);
                $desktopDateRangePicker.data('daterangepicker').setEndDate(appliedEndDate);
            }

            var $dateRangePickerDesktop = $('.daterangepicker').detach();

            // Initialize and detach the mobile date-picker

            $mobileDateRangePicker.daterangepicker({
                opens: 'center',
                minDate: moment(),
                maxDate: moment().add(travelByDays, 'days'),
                locale: dateRangePickerLocaleConfig
            });

            $mobileDateRangePicker.on('apply.daterangepicker', function(ev, picker) {

                applyTravelDates('mobile', picker);
            });

            $mobileDateRangePicker.on('cancel.daterangepicker', function(ev, picker) {

                clearTravelDates(true);
            });

            $mobileDateRangePicker.on('show.daterangepicker', function(ev, picker) {

                toggleButton($mobileDateRangePicker, 'on');

                $('body').addClass('date-range-picker-active');
            });

            $mobileDateRangePicker.on('hide.daterangepicker', function(ev, picker) {

                $mobileDateRangePicker.removeClass('current');

                $('body').removeClass('date-range-picker-active');
            });

            if (appliedStartDate !== '' && appliedEndDate !== '') {

                $mobileDateRangePicker.data('daterangepicker').setStartDate(appliedStartDate);
                $mobileDateRangePicker.data('daterangepicker').setEndDate(appliedEndDate);
            }

            var $dateRangePickerMobile = $('.daterangepicker').detach();

            // Re-attach the date-pickers to their required areas for proper display

            if (searchType === 'search-results') {

                $('.search-filter-controls').append($dateRangePickerDesktop);
                $('.search-filter-controls').append($dateRangePickerMobile);
            }
            else {

                $('.primary-filter-group-container').append($dateRangePickerDesktop);
                $('.search-filter-controls').append($dateRangePickerMobile);
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    loadSecondaryControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles setting up the "More Filters" / "Miscellaneous" related event handlers for all of the Search Process Interface Controls
        // **************************************************************************************************************
        var loadSecondaryControls = function() {

            // **************************************************************************************************************
            // Primary Filter Button Controls [More Filters]
            // **************************************************************************************************************
            $('.btn-more-filters-primary').click(function(e) { toggleFilter(e, $('.btn-more-filters-primary'), $('.more-filters')); });

            // **************************************************************************************************************
            // More Filters Secondary Button Controls & Mobile Interface Filter Controls
            // **************************************************************************************************************
            $('.js-filter-section').each(function(el) {

                $(this).click(function(e) {

                    // Close all other filter containers and reset their open class status
                    $('.js-filter-container').not($(this).next('.js-filter-container')).hide();
                    $('.js-filter-section').not($(this)).removeClass('open');

                    // Toggle the selected filter container and open class status
                    $(this).toggleClass('open');
                    $(this).next('.js-filter-container').toggle();
                });
            });

            // **************************************************************************************************************
            // Secondary Filter Checkbox Controls
            // **************************************************************************************************************
            $container.find('.secondary-filter-container .js-checkbox .js-filter-checkbox').each(function(el) {

                $(this).click(function(e) {

                    if (!isTransitioning) {

                        isTransitioning = true;

                        // Find the mobile filter version of the selected filter, so it can be manipulated appropriately as well
                        var selectedMobileFilter = $mobileContainer.find('[name="' + $(this).attr('name') + '"]');

                        if ($(this).hasClass('js-occupancy') || $(this).hasClass('js-rating')) {

                            // This is an occupancy or rating filter, we need to uncheck its siblings (it is treated like a radio button)

                            $(this).closest('.js-checkbox').siblings().find('.js-filter-checkbox').prop('checked',false);
                            selectedMobileFilter.closest('.js-checkbox').siblings().find('.js-filter-checkbox').prop('checked',false);
                        }

                        // Determine if we are unchecking a selection that may cause a zero result search due to other disabled selections in the same category

                        if ($(this).hasClass('js-amenity') || $(this).hasClass('js-activity')) {

                            // Amenities and Activities are split into two columns, but both columns need to be validated against for this function

                            checkDisabledSelections($(this), $(this).closest('.js-filter-set-container'));
                            checkDisabledSelections(selectedMobileFilter, selectedMobileFilter.closest('.js-filter-set-container'));
                        }
                        else {

                            checkDisabledSelections($(this), $(this).closest('.secondary-filter-option-container'));
                            checkDisabledSelections(selectedMobileFilter, selectedMobileFilter.closest('.secondary-filter-option-container'));
                        }

                        // Determine if we have any filter selections
                        var filterSection = $(this).closest('.filter-set').data('filter-section');
                        var filterItems   = checkFilterSelections($(this).closest('.filter-set'));

                        if (filterItems) {

                            $(filterSection).addClass('selected');
                        }
                        else {

                            $(filterSection).removeClass('selected');
                        }

                        if (checkFilterSelections($secondaryFilterControls)) {

                            toggleResetButton('secondary', 'on');
                        }
                        else {

                            toggleResetButton('secondary', 'off');
                        }

                        performFacetedSearch($(this).attr('name'));
                    }
                    else {

                        e.preventDefault();
                    }
                });
            });

            // **************************************************************************************************************
            // Primary Filter Section Close Button Controls
            // **************************************************************************************************************
            $closeButtons.each(function(el) {

                $(this).click(function(e) {

                    isTransitioning = true;
                    toggleButton($($(this).data('button')), 'off');
                    closeFilterSet($(this).closest('.js-primary-filter-container'));
                });
            });

            // **************************************************************************************************************
            // Back to Top Control
            // **************************************************************************************************************
            $('.js-back-to-top').click(function() {

                $('html, body').animate({
                    scrollTop: $('.site-main-container').offset().top
                }, 300);
            });

            // **************************************************************************************************************
            // Reset Secondary Filters Control
            // **************************************************************************************************************
            $('.js-reset-more-filters').click(function() {

                if (!isTransitioning) {

                    isTransitioning = true;
                    clearSecondaryFilters(true);
                }
            });

            // **************************************************************************************************************
            // View More Results Secondary Control
            // **************************************************************************************************************
            $('.view-more-controls').click(function(e) {

                if (!isTransitioning) {

                    if ($secondaryControlsContainer.is(':visible')) {

                        isTransitioning = true;

                        if (currentShowingCount < currentResortCount) {

                            performFacetedSearch('more-results');
                        }
                    }
                }
            });

            // **************************************************************************************************************
            // Popstate event (Using the "Back" or "Forward" traversal buttons in the browser to move through the browser history)
            // **************************************************************************************************************
            $(window).on("popstate", function(e) {

                if (e.originalEvent.state !== null) {

                    var key = e.originalEvent.state.id;

                    if (key in historyStateLog) {

                        // The state we are looking for exists in the history state log, so use that cached data instead of performing an AJAX search

                        var dataJSON = historyStateLog[key];
                        currentResortPage = dataJSON.currentPage;
                        revertSearchInterface(dataJSON);
                    }
                    else {

                        // The state we are looking for doesn't currently exist in the history state log, so we need to reload the page
                        // This type of event should never occur, but we want to account for it just incase of some weird behavior

                        window.location = location.pathname;
                    }
                }
            });

            // **************************************************************************************************************
            // Check the window on the event of a resize, to determine if we need to switch our "screenMode" variable
            // **************************************************************************************************************
            $(window).on('resize', function() {

                if ($( window ).width() <= 767) {

                    // Change screen mode type and close all standard interface filter sets, to smooth transitions between interfaces
                    $primaryFilterSets.hide();
                    $buttonControls.removeClass('current');

                    $.magnificPopup.close();

                    if (screenMode === 'standard') {

                        if ($('.daterangepicker').is(':visible')) {

                            $desktopDateRangePicker.data('daterangepicker').hide();
                            $mobileDateRangePicker.data('daterangepicker').hide();
                        }

                        resetScrollPosition = false;
                        toggleMobileMenu('n/a', 'off');
                    }

                    screenMode = 'responsive';
                }
                else {

                    // Change screen mode type and close responsive interface filter set, to smooth transitions betweeen interfaces
                    $siteBodyContainer.removeClass('mobile-menu-open');
                    $mobileMenuOverlay.removeClass('js-search-overlay');

                    if (screenMode === 'responsive') {

                        if ($('.daterangepicker').is(':visible')) {

                            $desktopDateRangePicker.data('daterangepicker').hide();
                            $mobileDateRangePicker.data('daterangepicker').hide();
                        }

                        resetScrollPosition = false;
                        toggleMobileMenu('n/a', 'off');
                    }

                    screenMode = 'standard';
                }
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    loadMobileControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles setting up the "Mobile View" related event handlers for all of the Search Process Interface Controls
        // **************************************************************************************************************
        var loadMobileControls = function() {

            // **************************************************************************************************************
            // Mobile - Menu Toggling Controls
            // **************************************************************************************************************
            $('.js-mobile-search-menu-close').click(function(e) {

                toggleMobileMenu('n/a', 'off');
            });

            $('#js-btn-mobile-menu-close-overlay').click(function(e) {

                if ($(this).hasClass('js-search-overlay')) {

                    toggleMobileMenu('n/a', 'off');
                }
            });

            // **************************************************************************************************************
            // Mobile - Destinations Menu Control
            // **************************************************************************************************************
            $('.btn-destination-mobile').click(function(e) {

                toggleMobileMenu('destinations', 'on');
            });

            // **************************************************************************************************************
            // Mobile - More Filters Menu Control
            // **************************************************************************************************************
            $('.btn-more-filters-mobile').click(function(e) {

                toggleMobileMenu('more-filters', 'on');
            });

            // **************************************************************************************************************
            // Mobile - Destination [Region] Controls
            // **************************************************************************************************************
            $mobileContainer.find('.js-region-control').each(function() {

                $(this).click(function() {

                    if (!$(this).hasClass('disabled-selector')) {

                        var regionID              = $(this).data('region-id');
                        var targetRegionContainer = $mobileContainer.find('.js-region-container[data-region-id="' + regionID + '"]');
                        var singularSubRegion     = targetRegionContainer.data('singular-sub-region');

                        $mobileContainer.find('.js-region-container').hide();
                        $mobileContainer.find('.js-sub-region-container').hide();
                        $('.js-mobile-destination-controls').hide();

                        if (singularSubRegion === 'NA') {

                            $('.js-mobile-region-containers-view').show();
                            targetRegionContainer.show();
                        }
                        else {

                            $('.js-mobile-sub-region-containers-view').show();
                            $mobileContainer.find('.js-sub-region-container[data-sub-region-id="' + singularSubRegion + '"]').show();
                        }
                    }
                });
            });

            // **************************************************************************************************************
            // Mobile - Destination [Sub-Region] Controls
            // **************************************************************************************************************
            $mobileContainer.find('.js-sub-region-control').each(function() {

                $(this).click(function() {

                    if (!$(this).hasClass('disabled-selector')) {

                        var regionID    = $(this).closest('.js-region-container').data('region-id');
                        var subRegionID = $(this).data('sub-region-id');

                        $mobileContainer.find('.js-region-container').hide();
                        $mobileContainer.find('.js-sub-region-container').hide();
                        $('.js-mobile-destination-controls').hide();

                        $('.js-mobile-sub-region-containers-view').show();
                        $mobileContainer.find('.js-sub-region-container[data-sub-region-id="' + subRegionID + '"]').show();
                    }
                });
            });

            // **************************************************************************************************************
            // Mobile - Check All [Destinations] Checkbox Filter Controls
            // **************************************************************************************************************
            $mobileContainer.find('.js-check-all').each(function(el) {

                $(this).click(function(e) {

                    if (!isTransitioning) {
                        // Acquire the primary filter control version of this mobile search control, and activate it
                        // This is done because the mobile filter controls are not replicated events of the primary interface, which performs all of the actual searching logic

                        var buttonType            = $(this).data('button-type');
                        var selectedPrimaryButton = '';

                        if (buttonType === 'sub-region') {

                            var subRegionID       = $(this).closest('.js-sub-region-container').data('sub-region-id');
                            selectedPrimaryButton = $container.find('.js-sub-region-container[data-sub-region-id="' + subRegionID + '"]').find('.js-check-all');
                        }
                        else {

                            var regionID          = $(this).closest('.js-region-container').data('region-id');
                            selectedPrimaryButton = $container.find('.js-region-container[data-region-id="' + regionID + '"]').find('.js-check-all');
                        }

                        selectedPrimaryButton.trigger('click');
                    }
                    else {

                        e.preventDefault();
                    }
                });
            });

            // **************************************************************************************************************
            // Mobile - Destination [Back To] Controls
            // **************************************************************************************************************
            $mobileContainer.find('.js-back-control').each(function() {

                $(this).click(function() {

                    var backContainer = $(this).closest('.js-container');
                    var regionID      = backContainer.data('region-id');

                    $mobileContainer.find('.js-region-container').hide();
                    $mobileContainer.find('.js-sub-region-container').hide();
                    $('.js-mobile-destination-controls').hide();

                    if (backContainer.hasClass('js-region-container') || backContainer.data('is-singular-sub-region') === 'yes') {

                        $('.js-mobile-region-controls-view').show();
                    }
                    else {

                        $('.js-mobile-region-containers-view').show();
                        $mobileContainer.find('.js-region-container[data-region-id="' + regionID + '"]').show();
                    }
                });
            });

            // **************************************************************************************************************
            // Mobile - Checkbox Filter Controls
            // **************************************************************************************************************
            $mobileContainer.find('.js-filter-checkbox').each(function(el) {

                $(this).click(function(e) {

                    if (!isTransitioning) {

                        // Acquire the primary filter control version of this mobile search control, and activate it
                        // This is done because the mobile filter controls are not replicated events of the primary interface, which performs all of the actual searching logic

                        var selectedPrimaryFilter = $container.find('[name="' + $(this).attr('name') + '"]');
                        selectedPrimaryFilter.trigger('click');
                    }
                    else {

                        e.preventDefault();
                    }
                });
            });

            // **************************************************************************************************************
            // Mobile - Slider Checkbox - Hide All-Inclusive [Custom Slider Button] Control
            // **************************************************************************************************************
            $mobileContainer.find('.js-slider-hide-ai').each(function(el) {

                $(this).click(function(e) {

                    if (!isTransitioning) {

                        // Acquire the primary filter control version of this mobile search control, and activate it
                        // This is done because the mobile filter controls are not replicated events of the primary interface, which performs all of the actual searching logic

                        var selectedPrimaryFilter = $container.find('.js-slider-hide-ai');
                        selectedPrimaryFilter.trigger('click');
                    }
                    else {

                        e.preventDefault();
                    }
                });
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    loadCustomControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles instantiating any custom form controls for the search process
        // **************************************************************************************************************
        var loadCustomControls = function() {

            // **************************************************************************************************************
            // Custom Button [Toggling] Controls
            // **************************************************************************************************************
            $('.js-custom-button').each(function() {

                $(this).find('.btn-custom-label').on('click', function(e) {

                    if (!isTransitioning) {

                        // Ensure we stop click propagation from moving up further and hitting the click management
                        // event that exists on the <html> DOM element of the page. Instead, manage all click related
                        // events locally in this specific click event handler
                        e.stopPropagation();

                        var button = $(this).parents('.btn-custom');

                        if (!button.hasClass('current')) {

                            $('.js-custom-button .btn-custom').removeClass('current');

                            $primaryFilterSets.each(function(el) {

                                if ($(this).is(':visible')) { $(this).hide(); }
                            });

                            toggleButton(button, 'on');
                        }
                        else {

                            toggleButton(button, 'off');
                        }
                    }
                });
            });

            // **************************************************************************************************************
            // Sort By [Custom Button -> Custom Dropdown] Control
            // **************************************************************************************************************
            $('.js-sort').find('.custom-select-option').on('click', function() {

                // Update the custom interface dropdown elements and labels
                $(this).parents('.custom-select-options').find('.custom-select-option').removeClass('selected');
                $(this).addClass('selected');
                $(this).parents('.btn-custom').removeClass('current');
                $(this).parents('.btn-custom').find('.btn-custom-label').text($(this).text());

                // Update the true DOM input elements, but only if the sort value has changed
                if ($sortFilter.val() !== $(this).data('value')) {
                    isTransitioning = true;
                    $sortFilter.val($(this).data('value'));
                    performFacetedSearch('bypass');
                }
            });

            // **************************************************************************************************************
            // Slider Checkbox - Hide All-Inclusive [Custom Slider Button] Control
            // **************************************************************************************************************
            $container.find('.js-slider-hide-ai').on('click', function() {

                isTransitioning = true;
                //performFacetedSearch('bypass');
                performFacetedSearch($(this).attr('name'));
            });

            // **************************************************************************************************************
            // Click Management Controls [Toggles modals / dropdowns closed when an outside container click is detected]
            // **************************************************************************************************************
            $('html').click(function(e) {

                if ($('.destinations-type-ahead-container').is(':visible')) {

                    if (! $(e.target).closest('.destinations-type-ahead-modal')[0]) {
                        $('.destinations-type-ahead-container').hide();
                        $('.btn-destination-primary').removeClass('current current-no-toggle');
                    }
                }

                if ($('.primary-destination-filters').is(':visible')) {

                    if (! $(e.target).closest('.destinations-legacy-modal')[0]) {
                        $('.js-legacy-destination-toggle').trigger('click');
                    }
                }

                if ($('.more-filters-container').is(':visible')) {

                    if (! $(e.target).closest('.more-filters-modal')[0]) {
                        $('.btn-more-filters-primary').trigger('click');
                    }
                }

                $('.js-custom-button .btn-custom').removeClass('current');
            });

            // **************************************************************************************************************
            // Arrow Key Management Controls [Traverses selectable search criteria in the type ahead dropdown modal]
            // **************************************************************************************************************
            $('body').on('keydown', function(e) {

                if ($('.destinations-type-ahead-container').is(':visible')) {

                    var keyStrokeCode = e.which;

                    if (keyStrokeCode === 38 || keyStrokeCode === 40) {

                        // Ensure we stop click propagation from moving up further and hitting the click management
                        // event that exists on the <html> DOM element of the page. Instead, manage all click related
                        // events locally in this specific click event handler
                        e.stopPropagation();

                        var criteriaGroup = $('.search-criteria');
                        var counter       = 0;
                        var initialIndex  = -1;

                        criteriaGroup.each(function() {

                            if ($(this).hasClass('hover-highlight')) {
                                initialIndex = counter;
                                return false;
                            }

                            counter++;
                        });

                        if (initialIndex > -1) {
                            var originSelector = $('.search-criteria')[initialIndex];
                            $(originSelector).removeClass('hover-highlight');
                        }

                        var prevSelector = (initialIndex <= 0) ? $('.search-criteria')[criteriaGroup.length - 1] : $('.search-criteria')[initialIndex - 1];
                        var nextSelector = (initialIndex === (criteriaGroup.length - 1)) ? $('.search-criteria')[0] : $('.search-criteria')[initialIndex + 1];

                        if (keyStrokeCode === 38) {
                            $(prevSelector).addClass('hover-highlight');
                        }
                        else {
                            $(nextSelector).addClass('hover-highlight');
                        }
                    }
                    else if (keyStrokeCode === 13) {

                        var selectedCriteria;

                        if ($('.hover-highlight').length) {
                            selectedCriteria = $('.hover-highlight')[0];
                        }
                        else {
                            selectedCriteria = $('.js-matches-criteria').find('.search-criteria').first();
                        }

                        if ($(selectedCriteria).length) {
                            $(selectedCriteria).trigger('click');
                        }
                    }
                }
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    loadErrorControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles instantiating any error form controls for the availability process
        // **************************************************************************************************************
        var loadErrorControls = function() {

            // **************************************************************************************************************
            // Error Message Controls
            // **************************************************************************************************************
            $('.error-message-container').click(function() {

                $('.js-error-message').slideUp($.extend({}, animationParameters));
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    loadTourControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles the initial loading requirements for the guided search tour
        // **************************************************************************************************************
        var loadTourControls = function() {

            intro = introJs();

            intro.onexit(function() {

                $('body').removeClass('tour-overlay-container');
                $('.search-filter-controls').removeClass('tour-position-container');
                $('.hybrid-map-results').removeClass('tour-position-container');
            });

            tourInitialized = true;

            $('.js-tour-search-process').click(function(e) {

                if (tourInitialized) {

                    $('body').addClass('tour-overlay-container');
                    $('html, body').scrollTop(0);
                    $('.search-filter-controls').addClass('tour-position-container');
                    $('.hybrid-map-results').addClass('tour-position-container');

                    // Sequentially create the appropriate guided tour steps based on the current state of the search interface

                    var tourSteps = [];

                    tourSteps.push(
                        {
                            intro: "Need help getting started with the new search process? Let us show you how it works!"
                        }
                    );

                    tourSteps.push(
                        {
                            element: document.getElementsByClassName('btn-destination-primary')[0],
                            intro: "You can start by typing any destination or Resort Name, and we'll search for the best possible matches.",
                            position: 'bottom-middle-aligned',
                            tooltipClass: 'intro-tour-step-2-positioner'
                        }
                    );

                    tourSteps.push(
                        {
                            element: document.getElementsByClassName('btn-destination-primary')[0],
                            intro: "...or, you can click the arrow icon to use a more traditional destination selection tool.",
                            position: 'right',
                            tooltipClass: 'intro-tour-step-3-positioner'
                        }
                    );

                    tourSteps.push(
                        {
                            element: document.getElementsByClassName('btn-travel-dates-primary')[0],
                            intro: "You can also select a travel date range using this field.",
                            position: 'bottom-middle-aligned',
                            tooltipClass: 'intro-tour-generic-positioner'
                        }
                    );

                    tourSteps.push(
                        {
                            element: document.getElementsByClassName('btn-more-filters-primary')[0],
                            intro: "Add any other filters that are important to your search here.",
                            position: 'bottom-middle-aligned',
                            tooltipClass: 'intro-tour-generic-positioner'
                        }
                    );

                    tourSteps.push(
                        {
                            element: document.getElementsByClassName('search-bar-wrapper')[0],
                            intro: "All of the options in the search bar are optional, so feel free to change them as often as you like!",
                            position: 'bottom-right-aligned',
                            tooltipClass: 'intro-tour-step-6-positioner'
                        }
                    );

                    // Ensure that the google map and list cards are available for the guided tour interface to utilize

                    if (!$staticContentContainer.is(':visible')) {

                        tourSteps.push(
                            {
                                element: '#map-canvas',
                                intro: "You can also browse the map or click on the pins to get more information for any resort.",
                                position: 'left'
                            }
                        );

                        tourSteps.push(
                            {
                                element: document.getElementsByClassName('refresh-map-button')[0],
                                intro: "You can even search your current map view by clicking the 'Search This Area' button.",
                                position: 'bottom-middle-aligned',
                                tooltipClass: 'intro-tour-generic-positioner'
                            }
                        );

                        tourSteps.push(
                            {
                                element: document.getElementsByClassName('js-sort')[0],
                                intro: "Sort your results however you prefer!",
                                position: 'bottom-middle-aligned',
                                tooltipClass: 'intro-tour-generic-positioner'
                            }
                        );

                        tourSteps.push(
                            {
                                element: document.getElementsByClassName('resort-primary-container')[0],
                                intro: "Hovering over your chosen resort will bounce the matching pin on the map.",
                                position: 'right'
                            }
                        );

                        tourSteps.push(
                            {
                                element: document.getElementsByClassName('map-locator')[0],
                                intro: "...or, click the locator icon to have the map take you directly to the pin!",
                                position: 'right'
                            }
                        );
                    }

                    tourSteps.push(
                        {
                            intro: "Thats all there is to it... Start searching for your next vacation!"
                        }
                    );

                    intro.setOptions({
                        showProgress: true,
                        showStepNumbers: false,
                        keyboardNavigation: true,
                        exitOnEsc: true,
                        showBullets: false,
                        disableInteraction: true,
                        nextLabel: '⇨',
                        prevLabel: '⇦',
                        skipLabel: 'Done',
                        doneLabel: 'Done',
                        hidePrev: true,
                        hideNext: true,
                        scrollToElement: false,
                        tooltipPosition: 'bottom-middle-aligned',
                        steps: tourSteps
                    });

                    intro.start();
                }
            });

            // Show the tour icon and then animate the helper popup to briefly get the user's attention

            $('.js-tour-search-process').show(600, function() {

                setTimeout(function() {

                    $('.tour-popup-helper').css('visibility', 'visible');

                    $('.tour-popup-helper').fadeTo('slow', 1, function() {

                        $('.tour-popup-helper').delay(5000).fadeTo('slow', 0, function() {

                            $('.tour-popup-helper').css('visibility', 'hidden');
                        });
                    });

                }, 5000);
            });
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                              GOOGLE MAP FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    mapApiLoadCheck
        // PARAMETERS:  none
        // DESCRIPTION: This function handles checking for initial google map load completion, then initializing map dependent controls
        // **************************************************************************************************************
        var mapApiLoadCheck = function() {

            if (isMapsApiLoaded) {

                clearInterval(intervalCheck);
                initializeMapView();
                initializeControls();
            }
        }

        // **************************************************************************************************************
        // FUNCTION:    getMapConfiguration
        // PARAMETERS:  none
        // DESCRIPTION: This function handles instantiating the google map the first time it is called, and loading in the appropriate initial markers
        // **************************************************************************************************************
        var getMapConfiguration = function() {

            var mapOptions = {
                zoom: 5,
                minZoom: 3,
                maxZoom: 15,
                center: new google.maps.LatLng(0, 0),
                mapTypeControl: false,
                scrollwheel: false,
                fullscreenControl: false,
                streetViewControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                styles: [
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "saturation": "-100"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "color": "#545454"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "saturation": "-87"
                            },
                            {
                                "lightness": "-40"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#f0f0f0"
                            },
                            {
                                "saturation": "-22"
                            },
                            {
                                "lightness": "-16"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "saturation": "-52"
                            },
                            {
                                "hue": "#00e4ff"
                            },
                            {
                                "lightness": "-16"
                            }
                        ]
                    }
                ]
            };

            // Activate the initial map
            map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

            // Create and initialize the "Search This Area" control button on the map
            var searchAreaControl       = document.createElement('div');
            searchAreaControl.className = 'search-area-control';
            var searchAreaButton        = document.createElement('div');
            searchAreaButton.className  = 'refresh-map-button temporarily-disabled';
            var searchAreaMessage        = document.createElement('div');
            searchAreaMessage.className  = 'refresh-map-message';
            searchAreaMessage.innerHTML = 'Zoom-In Further To Search This Area';
            searchAreaButton.appendChild(searchAreaMessage);
            searchAreaControl.appendChild(searchAreaButton);

            // Check for click events on the "Search This Area" control button
            searchAreaButton.addEventListener('click', function() {

                if (!$('.refresh-map-button').hasClass('temporarily-disabled')) {

                    isTransitioning = true;
                    performMapSearch();
                }
            });

            // Add the "Search This Area" button to the google map control set
            map.controls[google.maps.ControlPosition.LEFT_TOP].push(searchAreaControl);

            // Check the google map viewable bounds after a drag event
            google.maps.event.addListener(map, 'dragend', function () {

                checkLatitude();
            });

            // Check the google map viewable bounds after an idle event
            google.maps.event.addListener(map, 'idle', function () {

                checkLatitude();
                refreshSearchAreaButton();
            });

            // Check the google map zoom level after a zoom change event
            google.maps.event.addListener(map, 'zoom_changed', function () {

                checkZoomLevel();
            });

            // One time event to check for when the map has loaded fully
            google.maps.event.addListenerOnce(map, 'tilesloaded', function() {

                // Use a short initial timeout to ensure the google map has time to catch up in its rendering of on-load items
                setTimeout(initializePostMapLoadItems, 500);
            });

            // Asynchronously load the Infobox.js and html-marker-local libraries, which have dependencies on the Google Map API being loaded first
            $.when(

                $.getScript( "/modules/search/snazzy-info-window.js" ),
                $.getScript( "/modules/search/html-marker-local.js" ),
                $.Deferred(function( deferred ){
                    $( deferred.resolve );
                })
            ).done(function(){

                infoBox = new SnazzyInfoWindow({
                    map: map,
                    content: 'Snazzy!',
                    placement: 'bottom',
                    openOnMarkerClick: false,
                    closeOnMapClick: true,
                    closeWhenOthersOpen: true,
                    panOnOpen: false,
                    showCloseButton: true,
                    padding: '0px',
                    border: false,
                    backgroundColor: 'transparent',
                    shadow: false,
                    offset: { top: '-22px', left: '0px'}
                });

                loadMapMarkers();
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    openMarkerInfoBox
        // PARAMETERS:  marker (the marker in the google map)
        //              resortID (the resort ID associated with the provided marker)
        //              infoBoxContent (the info box content to be loaded for the provided marker)
        // DESCRIPTION: This function handles the panning to and opening of the info box window for a particular google map marker
        // **************************************************************************************************************
        var openMarkerInfoBox = function(marker, resortID, infoBoxContent) {

            lastInfoBoxResort = resortID;

            infoBox.close();
            infoBox.setContent('');

            panToMarker(marker);

            google.maps.event.addListenerOnce(map, 'idle', function(){
                infoBox.setContent(infoBoxContent);
                infoBox.setPosition(marker.position);
                infoBox.open();
                map.setZoom(15);
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    panToMarker
        // PARAMETERS:  marker (the marker in the google map)
        // DESCRIPTION: This function handles the animation panning to a particular google map marker
        // **************************************************************************************************************
        var panToMarker = function(marker) {

            var offsetX        = 0;
            var offsetY        = 0;
            var scale          = Math.pow(2, map.getZoom());
            var center         = map.getProjection().fromLatLngToPoint(marker.getPosition());
            var newCenterPoint = new google.maps.Point(center.x - offsetX/scale, center.y + offsetY/scale );
            var newCenter      = map.getProjection().fromPointToLatLng(newCenterPoint)

            map.panTo(newCenter);
        };

        // **************************************************************************************************************
        // FUNCTION:    refreshSearchAreaButton
        // PARAMETERS:  none
        // DESCRIPTION: This function handles toggling the "Search This Area" button functionality between enabled and disabled
        // **************************************************************************************************************
        var refreshSearchAreaButton = function() {

            if (map.getZoom() >= minSearchAreaZoomLevel) {

                $('.refresh-map-button').removeClass('temporarily-disabled');
                $('.refresh-map-message').text('Search This Area');
            }
            else {

                $('.refresh-map-button').addClass('temporarily-disabled');
                $('.refresh-map-message').text('Zoom-In Further To Search This Area');
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    checkZoomLevel
        // PARAMETERS:  none
        // DESCRIPTION: This function handles ensuring the google map stays at a particular minimum zoom level
        // **************************************************************************************************************
        var checkZoomLevel = function() {

            if (map.getZoom() < minZoomLevel) {

                map.setZoom(parseInt(minZoomLevel));
            }
        }

        // **************************************************************************************************************
        // FUNCTION:    checkLatitude
        // PARAMETERS:  none
        // DESCRIPTION: This function determines if we have left the "viewable" space of the google map and entered a "gray bar" area,
        //              and then pans the user back to their last eligble and valid viewable center point
        // **************************************************************************************************************
        var checkLatitude = function() {

            var bounds = map.getBounds();
            var sLat   = map.getBounds().getSouthWest().lat();
            var nLat   = map.getBounds().getNorthEast().lat();

            if (sLat < -85 || nLat > 85) {

                // The map has gone beyone the world's max or min latitude - gray areas are visible

                if (lastValidCenter) {

                    map.panTo(lastValidCenter);
                }
            }
            else {

                // Calculate a new current valid center point that the user is viewing to retrace our steps toward

                lastValidCenter = map.getCenter();
            }
        }

        // **************************************************************************************************************
        // FUNCTION:    loadMapMarkers
        // PARAMETERS:  none
        // DESCRIPTION: This function handles creating the map markers and sets of bounds for the map to be viewed on, and loading them into the google map canvas
        // **************************************************************************************************************
        var loadMapMarkers = function() {

            bounds = new google.maps.LatLngBounds();

            var pinNumber = 1;

            $.each(googleMapData, function(key, value) {

                var marker;

                if (!usingDefaultMap) {

                    // Custom HTML marker pin for modern browsers

                    marker = createHTMLMapMarker({
                        position: new google.maps.LatLng(parseFloat(value.latitude), parseFloat(value.longitude)),
                        map: map,
                        html: value.markerHTML
                    });
                }
                else {

                    // Default marker pin for IE and older browsers, or if markerHTML is empty

                    marker = new google.maps.Marker({
                        position: {lat: Number(value.latitude), lng: Number(value.longitude)},
                        animation: google.maps.Animation.DROP,
                        map: map
                    });
                }

                markers[value.resortID] = marker;

                google.maps.event.addListener(marker, 'click', function() {

                    if (screenMode === 'standard') {

                        openMarkerInfoBox(marker, value.resortID, value.infoBox);
                    }
                });

                bounds.extend(new google.maps.LatLng(Number(value.latitude), Number(value.longitude)));

                // Find the list card associated with the current map marker and bind the hover event to pin bounce functionality
                $('.js-resort-id-' + value.resortID).hover(

                    function() {
                        // (Moue Enter) Bounce the map pin
                        animateMarker(value.resortID);
                    },
                    function() {
                        // (Mouse Leave) Do nothing
                        return false;
                    }
                );

                if (mapLocatorEnabled) {

                    // Find the list card locator icon associated with the current map marker and bind the click event to geo locate the marker on the google map
                    $('.js-resort-id-' + value.resortID).find('.js-locate-resort').click(function() { locateMarker(value.resortID) });
                }
            });

            // Fit the map to the new bounds calculation and trigger a resize map event
            setTimeout(fitMapToBounds, 100);

            // Check to see if we have any markers in our new viewable computed area
            // The timeout is required to ensure that the bounds have been set for the map object
            setTimeout(checkViewableMarkers, 300);
        };

        // **************************************************************************************************************
        // FUNCTION:    fitMapToBounds
        // PARAMETERS:  none
        // DESCRIPTION: This function fits the map to the bounds of the new markers. This is activated on a slight delay to allow
        //              asynchronously loading map items to finish before fitting new bounds, which resolves some minor bound zoom issues
        // **************************************************************************************************************
        var fitMapToBounds = function() {

            map.fitBounds(bounds);
            google.maps.event.trigger(map, 'resize');
        };

        // **************************************************************************************************************
        // FUNCTION:    checkViewableMarkers
        // PARAMETERS:  none
        // DESCRIPTION: This function determines if we have any map markers in our viewable bounds, and if not, centers our map on the first viewable marker position
        //              which ensures that we have at least one marker visible on the map
        // **************************************************************************************************************
        var checkViewableMarkers = function() {

            var count               = 0;
            var markerFound         = false;
            var currentMapBounds    = map.getBounds();
            var firstMarkerPosition = '';

            $.each(markers, function(key, marker) {

                if (count === 10) {

                    firstMarkerPosition = marker.getPosition();
                }

                if (currentMapBounds && currentMapBounds.contains(marker.getPosition())) {

                    markerFound = true;
                    return false;
                }

                count++;
            });

            if (!markerFound) {

                map.setCenter(firstMarkerPosition);
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    clearMarkersAndBounds
        // PARAMETERS:  none
        // DESCRIPTION: This function handles remove existing markers from the map and then deleting them from memory, as well as resetting the map bounds and infoboxes
        //              We only need to invoke this function if the map has been previously initialized, to ensure we have a clean slate
        // **************************************************************************************************************
        var clearMarkersAndBounds = function() {

            if (mapInitialized && mapEnableSwitch) {

                infoBox.close();

                $.each(markers, function(key, marker) {

                    // Destroy the existing click event tied to this marker
                    google.maps.event.clearListeners(marker, 'click');

                    // Disable any hover events for all list cards
                    $('.resort-list-card').each(function() {

                        $(this).off('hover');
                        $(this).off('click');
                    });

                    // Remove this marker from the map, and then delete it from memory
                    marker.setMap(null);
                    marker = null;
                });

                // Clear the markers array to reset memory
                markers = {};
                bounds  = '';
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    animateMarker
        // PARAMETERS:  resortID
        // DESCRIPTION: This function handles activating the bounce animation on a particular map marker pin. This isn't necessary when in responsive view mode
        // **************************************************************************************************************
        var animateMarker = function(resortID) {

            if (mapEnableSwitch && mapInitialized && screenMode === 'standard' && !isTransitioning) {

                if (lastInfoBoxResort !== resortID || !infoBox.isOpen()) {

                    if (!usingDefaultMap) {

                        markers[resortID].animateBounce();
                    }
                    else {

                        // Google animations for default map markers (IE / unsupported browsers ONLY)

                        if (markers[resortID].getAnimation() !== google.maps.Animation.BOUNCE) {

                            markers[resortID].setAnimation(google.maps.Animation.BOUNCE);
                            markers[resortID].setAnimation(null);
                        }
                        else {

                            markers[resortID].setAnimation(null);
                        }
                    }
                }
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    locateMarker
        // PARAMETERS:  resortID
        // DESCRIPTION: This function handles finding and displaying the location of a particular marker pin on the map. This isn't necessary when in responsive view mode
        // **************************************************************************************************************
        var locateMarker = function(resortID) {

            if (mapEnableSwitch && mapInitialized && screenMode === 'standard' && !isTransitioning) {

                new google.maps.event.trigger(markers[resortID], 'click');
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             TRAVEL DATES FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    getLocaleConfiguration
        // PARAMETERS:  localeLanguage (the locale language code for the requested configuration)
        // DESCRIPTION: This function handles acquiring local configurable parameters for the date range pickers
        // **************************************************************************************************************
        var getLocaleConfiguration = function(localeLanguage) {

            var configurationParams = {};

            switch (localeLanguage) {

                case 'en-gb':

                    configurationParams = {
                        "format": "DD/MM/YYYY",
                        "separator": " - ",
                        "applyLabel": "Apply",
                        "cancelLabel": "Reset Calendar",
                        "fromLabel": "From",
                        "toLabel": "To",
                        "weekLabel": "W",
                        "daysOfWeek": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                        "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        "firstDay": 1
                    };
                    break;

                case 'es':

                    configurationParams = {
                        "format": "DD/MM/YYYY",
                        "separator": " - ",
                        "applyLabel": "Aplicar",
                        "cancelLabel": "Restablecer calendario",
                        "fromLabel": "Desde",
                        "toLabel": "Hasta",
                        "weekLabel": "S",
                        "daysOfWeek": ["Do", "Lu", "Ma", "Mx", "Ju", "Vi", "Sa"],
                        "monthNames": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
                        "firstDay": 1
                    };
                    break;

                case 'pt-br':

                    configurationParams = {
                        "format": "DD/MM/YYYY",
                        "separator": " - ",
                        "applyLabel": "Aplique",
                        "cancelLabel": "Repor o calendário",
                        "fromLabel": "De",
                        "toLabel": "Até",
                        "weekLabel": "S",
                        "daysOfWeek": ["Do", "Sg", "Te", "Qa", "Qi", "Sx", "Sa"],
                        "monthNames": ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
                        "firstDay": 1
                    };
                    break;

                default:

                    configurationParams = {
                        "format": "MM/DD/YYYY",
                        "separator": " - ",
                        "applyLabel": "Apply",
                        "cancelLabel": "Reset Calendar",
                        "fromLabel": "From",
                        "toLabel": "To",
                        "weekLabel": "W",
                        "daysOfWeek": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                        "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        "firstDay": 1
                    };
            }

            return configurationParams;
        };

        // **************************************************************************************************************
        // FUNCTION:    applyTravelDates
        // PARAMETERS:  pickerType ("desktop" / "mobile")
        //              picker (the picker instance control that is being triggered)
        // DESCRIPTION: This function handles the event of applying new travel dates and then performing a faceted search
        // **************************************************************************************************************
        var applyTravelDates = function(pickerType, picker) {

            isTransitioning    = true;
            var updatedDisplay = '';

            $startDateControl.val(picker.startDate.format('MM-DD-YYYY'));
            $endDateControl.val(picker.endDate.format('MM-DD-YYYY'));

            updatedDisplay = (picker.startDate.format('MMM-DD-YY') + ' | ' + picker.endDate.format('MMM-DD-YY')).replace(/\./g, '');

            $desktopDateRangePickerLabel.val(updatedDisplay);
            $mobileDateRangePickerLabel.val(updatedDisplay);

            if (pickerType === 'mobile') {

                $desktopDateRangePicker.data('daterangepicker').setStartDate(picker.startDate);
                $desktopDateRangePicker.data('daterangepicker').setEndDate(picker.endDate);
            }
            else {

                $mobileDateRangePicker.data('daterangepicker').setStartDate(picker.startDate);
                $mobileDateRangePicker.data('daterangepicker').setEndDate(picker.endDate);
            }

            checkDatesAndSearch(true);
        };

        // **************************************************************************************************************
        // FUNCTION:    clearTravelDates
        // PARAMETERS:  runSearch (boolean value that decides whether a faceted search should be performed as part of this function call)
        // DESCRIPTION: This function handles the event of clearing all travel dates and then performing a faceted search
        // **************************************************************************************************************
        var clearTravelDates = function(runSearch) {

            isTransitioning    = true;
            var updatedDisplay = '';

            $startDateControl.val('');
            $endDateControl.val('');

            $desktopDateRangePickerLabel.val(updatedDisplay);
            $mobileDateRangePickerLabel.val(updatedDisplay);

            $desktopDateRangePicker.data('daterangepicker').setStartDate(moment());
            $desktopDateRangePicker.data('daterangepicker').setEndDate(moment());
            $mobileDateRangePicker.data('daterangepicker').setStartDate(moment());
            $mobileDateRangePicker.data('daterangepicker').setEndDate(moment());

            checkDatesAndSearch(runSearch);
        };

        // **************************************************************************************************************
        // FUNCTION:    checkDatesAndSearch
        // PARAMETERS:  runSearch (boolean value that decides whether a faceted search should be performed as part of this function call)
        // DESCRIPTION: This function handles the determination if selected travel dates require a new search to be processed
        // **************************************************************************************************************
        var checkDatesAndSearch = function(runSearch) {

            var performSearch  = false;
            var displayMessage = false;
            var startDate      = $startDateControl.val();
            var endDate        = $endDateControl.val();

            if (startDate !== '' && endDate !== '') {

                // We have a valid set of dates

                if (startDate !== appliedStartDate || endDate !== appliedEndDate) {

                    // The dates are different than the currently applied date range

                    // Update the previous travel date variables
                    previousStartDate = appliedStartDate;
                    previousEndDate   = appliedEndDate;

                    // Update the applied travel date variables
                    appliedStartDate  = startDate;
                    appliedEndDate    = endDate;
                    performSearch     = true;
                }
            }
            else if (startDate === '' && endDate === '') {

                // We have a cleared set of dates

                if (startDate !== appliedStartDate && endDate !== appliedEndDate) {

                    // The dates are different than the currently applied date range

                    // Update the previous travel date variables
                    previousStartDate = appliedStartDate;
                    previousEndDate   = appliedEndDate;

                    // Update the applied travel date variables
                    appliedStartDate  = startDate;
                    appliedEndDate    = endDate;
                    performSearch     = true;
                }
            }
            else {

                // We have an incomplete set of dates

                if (appliedStartDate !== '' && appliedEndDate !== '') {

                    // The user already had previously applied travel dates, so show them a message to indicate that they are still applied
                    displayMessage = true;
                }
            }

            if (displayMessage) {

                // Display the fixed modal error message

                $('.js-error-message').html('NOTE: Your current Travel Dates are ' + appliedStartDate + ' through ' + appliedEndDate + '.');
                $('.js-error-message').slideDown($.extend({}, animationParameters));
            }
            else {

                // Reset any existing error messaging

                $('.js-error-message').hide();
                $('.js-error-message').empty();
            }

            if (performSearch && runSearch) {

                performFacetedSearch('travel-dates');
            }
            else {

                isTransitioning = false;
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                    CHECK ALL REGION / SUB-REGION FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    updateAllCheckRegionButtons
        // PARAMETERS:  none
        // DESCRIPTION: This function handles refreshing all "Check All" region buttons in the user interface
        // **************************************************************************************************************
        var updateAllCheckRegionButtons = function() {

            $container.find('.js-region-container').each(function() {

                var regionContainer         = $(this);
                var checkRegionButton       = $(this).find('.js-check-all');
                var mobileCheckRegionButton = $mobileContainer.find('.js-region-container[data-region-id="' + regionContainer.data('region-id') + '"]').find('.js-check-all');
                var subRegionContainers     = $container.find('.js-sub-region-container[data-region-id="' + regionContainer.data('region-id') + '"]');

                // Update the desktop / mobile check all region buttons
                refreshCheckAllButton(subRegionContainers, checkRegionButton, mobileCheckRegionButton);
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    updateCheckRegionButton
        // PARAMETERS:  button (the "Check All" button to be updated)
        // DESCRIPTION: This function handles refreshing a single "Check All" region button in the user interface
        // **************************************************************************************************************
        var updateCheckRegionButton = function(button) {

            if (typeof button !== 'undefined') {

                var regionContainer         = button.closest('.js-region-container');
                var mobileCheckRegionButton = $mobileContainer.find('.js-region-container[data-region-id="' + regionContainer.data('region-id') + '"]').find('.js-check-all');
                var subRegionContainers     = $container.find('.js-sub-region-container[data-region-id="' + regionContainer.data('region-id') + '"]');

                // Update the desktop / mobile check all region button
                refreshCheckAllButton(subRegionContainers, button, mobileCheckRegionButton);
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    updateAllCheckSubRegionButtons
        // PARAMETERS:  none
        // DESCRIPTION: This function handles refreshing all "Check All" sub-region buttons in the user interface
        // **************************************************************************************************************
        var updateAllCheckSubRegionButtons = function() {

            $container.find('.js-sub-region-container').each(function() {

                var subRegionContainer         = $(this);
                var checkSubRegionButton       = $(this).find('.js-check-all');
                var mobileCheckSubRegionButton = $mobileContainer.find('.js-sub-region-container[data-sub-region-id="' + subRegionContainer.data('sub-region-id') + '"]').find('.js-check-all');

                // Update the desktop / mobile check all sub-region button
                refreshCheckAllButton(subRegionContainer, checkSubRegionButton, mobileCheckSubRegionButton);
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    updateCheckSubRegionButton
        // PARAMETERS:  button (the "Check All" button to be updated)
        // DESCRIPTION: This function handles refreshing a single "Check All" sub-region button in the user interface
        // **************************************************************************************************************
        var updateCheckSubRegionButton = function(button) {

            if (typeof button !== 'undefined') {

                var subRegionContainer         = button.closest('.js-sub-region-container');
                var mobileCheckSubRegionButton = $mobileContainer.find('.js-sub-region-container[data-sub-region-id="' + subRegionContainer.data('sub-region-id') + '"]').find('.js-check-all');

                // Update the desktop / mobile check all sub-region button
                refreshCheckAllButton(subRegionContainer, button, mobileCheckSubRegionButton);
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    refreshCheckAllButton
        // PARAMETERS:  filterSource (the parent element that contains the "Check All" button that needs to be updated)
        //              button (the desktop mode "Check All" button to be updated)
        //              mobileButton (the mobile mode "Check All" button to be updated)
        // DESCRIPTION: This function handles refreshing a single "Check All" button in the user interface
        // **************************************************************************************************************
        var refreshCheckAllButton = function(filterSource, button, mobileButton) {

            var hasAllChecked = checkAllFilterSelections(filterSource);
            var hasEnabled    = checkAvailableFilterSelections(filterSource);
            var updatedText   = '';

            if (hasEnabled) {

                button.removeClass('disabled');
                mobileButton.removeClass('disabled');

                if (hasAllChecked) {

                    // All options are already checked, therefore we need to set this to the "selected" state where it becomes an "Uncheck All" button

                    button.addClass('selected');
                    mobileButton.addClass('selected');
                    updatedText = 'Uncheck All';
                    button.text(updatedText);
                    mobileButton.text(updatedText);
                }
                else {

                    // At least one option is available to be checked, therefore this button should be set to the standard state

                    button.removeClass('selected');
                    mobileButton.removeClass('selected');
                    updatedText = 'Check All';
                    button.text(updatedText);
                    mobileButton.text(updatedText);
                }
            }
            else {

                button.removeClass('selected');
                mobileButton.removeClass('selected');
                button.addClass('disabled');
                mobileButton.addClass('disabled');
                updatedText = 'Check All';
                button.text(updatedText);
                mobileButton.text(updatedText);
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                              TYPE AHEAD FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    performTypeAheadSearch
        // PARAMETERS:  searchCriteria (the typed input data from the user interface to be searched for)
        // DESCRIPTION: This function handles performing a type ahead search using previous search history and type ahead data
        // **************************************************************************************************************
        var performTypeAheadSearch = function(searchCriteria) {

            var maxCriteria           = 9;
            var destinationItemsToAdd = 0;
            var resortItemsToAdd      = 0;
            var historyItemsToAdd     = 0;
            var otherItemsToAdd       = 0;

            // Acquire all verified previous search history items to display
            var resultsHistory        = searchTypeAheadHistoryData();
            var numHistory            = resultsHistory.length;
            maxCriteria               = (numHistory >= 3) ? maxCriteria - 3 : maxCriteria - numHistory;

            var resultsDestinations   = [];
            var resultsResorts        = [];
            var numDestinations       = 0;
            var numResorts            = 0;

            if (searchCriteria !== '') {

                // Determine and obtain destination items to display

                resultsDestinations   = searchTypeAheadData(typeAheadData.destinations, searchCriteria, maxCriteria);
                numDestinations       = resultsDestinations.length;
                maxCriteria           = (numDestinations >= 3) ? maxCriteria - 3 : maxCriteria - numDestinations;

                // Determine and obtain resort items to display

                resultsResorts        = searchTypeAheadData(typeAheadData.resorts, searchCriteria, maxCriteria);
                numResorts            = resultsResorts.length;
                maxCriteria           = (numResorts >= 3) ? maxCriteria - 3 : maxCriteria - numResorts;
            }

            if (numHistory >= 3) {

                // Default item capacities when sufficient destination / resort (6) items and history (3) items exist to fill results capacity (9)
                historyItemsToAdd = 3;
                otherItemsToAdd   = ((numDestinations + numResorts) >= 6) ? 6 : (numDestinations + numResorts);

                if (otherItemsToAdd < 6) {

                    // Fill the results void meant for destination / resort items with history items (up to the maximum number of history items available)
                    historyItemsToAdd = (numHistory >= (9 - otherItemsToAdd)) ? (9 - otherItemsToAdd) : numHistory;
                }
            }
            else {

                historyItemsToAdd = numHistory;
                otherItemsToAdd   = ((numDestinations + numResorts) >= (9 - numHistory)) ? (9 - numHistory) : (numDestinations + numResorts);
            }

            if (otherItemsToAdd > 0) {

                if (numDestinations >= 3) {

                    // Default item capacities when sufficient destination (3) items, resort (3) items and history (3) items exist to fill results capacity (9)
                    destinationItemsToAdd = 3;
                    resortItemsToAdd      = (numResorts >= 3) ? 3 : numResorts;

                    if (resortItemsToAdd < 3) {

                        // Fill the results void meant for resort items with destination items (up to the maximum number of destination items available)
                        destinationItemsToAdd = (numDestinations >= (otherItemsToAdd - resortItemsToAdd)) ? (otherItemsToAdd - resortItemsToAdd) : numDestinations;
                    }
                    else if (otherItemsToAdd > 6) {

                        var missingItems = otherItemsToAdd - 6;
                        var destsLeft    = numDestinations - destinationItemsToAdd;
                        var resortsLeft  = numResorts - resortItemsToAdd;

                        if (destsLeft >= missingItems) {

                            destinationItemsToAdd = destinationItemsToAdd + missingItems;
                        }
                        else {

                            destinationItemsToAdd = destinationItemsToAdd + destsLeft;
                            missingItems          = missingItems - destsLeft;

                            if (resortsLeft >= missingItems) {

                                resortItemsToAdd = resortItemsToAdd + missingItems;
                            }
                            else {

                                resortItemsToAdd = resortItemsToAdd + resortsLeft;
                            }
                        }
                    }
                }
                else {

                    destinationItemsToAdd = numDestinations;
                    resortItemsToAdd      = (numResorts >= (otherItemsToAdd - numDestinations)) ? (otherItemsToAdd - numDestinations) : numResorts;
                }
            }

            // Filter down each set of results to the correct number of items to be displayed based on the above calculations
            resultsDestinations = resultsDestinations.slice(0, destinationItemsToAdd);
            resultsResorts      = resultsResorts.slice(0, resortItemsToAdd);
            resultsHistory      = resultsHistory.slice(0, historyItemsToAdd);

            // Determine if we should be displaying the reset controls
            if (checkDestinationFilters()) {

                $('.btn-destination').addClass('selected');
                toggleResetButton('destinations', 'on');
            }
            else {

                toggleResetButton('destinations', 'off');
            }

            // Build the content for the dropdown container

            $('.js-matches-criteria').find('.search-criteria').each(function() {

                $(this).off('click');
            });

            $('.js-matches-criteria').html('');

            var displayLabel = '';
            var postLabel    = '';
            var resultHTML   = '';
            var labelType    = '';
            var hasAlert     = false;
            var showMessage  = false;

            // Dropdown Container - Matches Results

            if ((destinationItemsToAdd + resortItemsToAdd) > 0) {

                resultsDestinations.sort(sortTypeAheadData);
                resultsResorts.sort(sortTypeAheadData);

                var mergedDataArray = $.merge(resultsDestinations, resultsResorts);

                $.each(mergedDataArray, function(index, item) {

                    labelType    = (item.typeID === 'resort') ? 'resort-item' : 'destination-item';
                    displayLabel = highlightMatches(item.displayLabel, searchCriteria);
                    postLabel    = (item.displayPostLabel !== '') ? ' <span class="post-label">(' + item.displayPostLabel + ')</span>' : '';
                    hasAlert     = (item.typeID !== 'resort') ? checkAllControlsDisabled(item.typeID, item.interfaceID) : false;
                    showMessage  = (hasAlert) ? true : showMessage;
                    resultHTML  += '<div class="search-criteria ' + labelType + (hasAlert ? ' filter-alert' : '') + '" data-type-id="' + item.typeID + '" data-interface-id="' + item.interfaceID +'"><div class="labels">' + displayLabel + postLabel + '</div></div>';
                });

                $('.js-matches-criteria').append(resultHTML);

                $('.js-matches-criteria').find('.search-criteria').each(function() {

                    $(this).click(function(e) {

                        var typeID      = $(this).data('type-id');
                        var interfaceID = $(this).data('interface-id');
                        searchByTypeAheadSelection(typeID, interfaceID);
                    });
                });

                $('.js-typeahead-message-start').hide();
                $('.js-typeahead-message-no-matches').hide();
            }
            else {

                if (searchCriteria === '') {

                    $('.js-typeahead-message-start').show();
                    $('.js-typeahead-message-no-matches').hide();
                }
                else {

                    $('.js-typeahead-message-no-matches').show();
                    $('.js-typeahead-message-start').hide();
                }
            }

            // Dropdown Container - Previous Searches Results

            $('.js-previous-criteria').find('.search-criteria').each(function() {

                $(this).off('click');
            });

            $('.js-previous-criteria').html('');

            if (historyItemsToAdd > 0) {

                resultHTML = '';

                $.each(resultsHistory, function(index, item) {

                    labelType   = (item.typeID === 'resort') ? 'resort-item' : 'destination-item';
                    postLabel   = (item.displayPostLabel !== '') ? ' <span class="post-label">(' + item.displayPostLabel + ')</span>' : '';
                    hasAlert    = (item.typeID !== 'resort') ? checkAllControlsDisabled(item.typeID, item.interfaceID) : false;
                    showMessage = (hasAlert) ? true : showMessage;
                    resultHTML += '<div class="search-criteria ' + labelType + (hasAlert ? ' filter-alert' : '') + '" data-type-id="' + item.typeID + '" data-interface-id="' + item.interfaceID +'"><div class="labels">' + item.displayLabel + postLabel + '</div></div>';
                });

                $('.js-previous-criteria').append(resultHTML);

                $('.js-previous-criteria').find('.search-criteria').each(function() {

                    $(this).click(function(e) {

                        var typeID      = $(this).data('type-id');
                        var interfaceID = $(this).data('interface-id');
                        searchByTypeAheadSelection(typeID, interfaceID);
                    });
                });

                $('.js-previous-search-container').show();
            }
            else {

                $('.js-previous-search-container').hide();
            }

            // Dropdown Container - Messaging For Required Filter Reset

            if (showMessage) {

                $('.js-messaging-container').show();
            }
            else {

                $('.js-messaging-container').hide();
            }

            // Search Criteria - Hover Event Controls
            // These are not done with a CSS hover because we need to allow for arrow keypress highlight hovering as well

            $('.search-criteria').each(function() {

                $(this).off('hover');
            });

            $('.search-criteria').hover(

                function() {
                    // (Moue Enter)
                    $('.search-criteria').removeClass('hover-highlight');
                    $(this).addClass('hover-highlight');
                },
                function() {
                    // (Mouse Leave)
                    $('.search-criteria').removeClass('hover-highlight');
                }
            );
        };

        // **************************************************************************************************************
        // FUNCTION:    searchTypeAheadData
        // PARAMETERS:  searchableData (The type ahead data set to be used as the basis for the search)
        //              searchCriteria (The type ahead criteria to search for in the basis data)
        //              maxCriteria (The maximum number of entries we want to return, allowing for short circuiting the search process early)
        // DESCRIPTION: This function handles traversing and locating specific search criteria in the type ahead destinations search interface
        // **************************************************************************************************************
        var searchTypeAheadData = function(searchableData, searchCriteria, maxCriteria) {

            var results = [];
            var count   = 0;

            $.each(searchableData, function(index, item) {

                if (count === maxCriteria) return false;

                if (item.searchLabel.indexOf(searchCriteria) !== -1) {

                    results.push(item);
                    count++;
                }
            });

            return results;
        };

        // **************************************************************************************************************
        // FUNCTION:    sortTypeAheadData
        // PARAMETERS:  a, b (the two values to sort between)
        // DESCRIPTION: This function handles sorting type ahead data by the displayLabel field in alphabetical order
        // **************************************************************************************************************
        var sortTypeAheadData = function(a, b) {

            var aName = a.displayLabel.toLowerCase();
            var bName = b.displayLabel.toLowerCase();

            return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
        }

        // **************************************************************************************************************
        // FUNCTION:    searchTypeAheadHistoryData
        // PARAMETERS:  none
        // DESCRIPTION: This function handles verifying that all existing previous search history items are still valid
        // **************************************************************************************************************
        var searchTypeAheadHistoryData = function() {

            var results = [];

            if (typeAheadHistory.length > 0) {

                $.each(typeAheadHistory, function(index, value) {

                    var codeArray   = value.split(':');
                    var codeType    = codeArray[0];
                    var codeID      = codeArray[1];
                    var historyItem = verifyTypeAheadData(codeType, codeID);

                    if (historyItem !== '') {

                        results.push(historyItem);
                    }
                });
            }

            return results;
        };

        // **************************************************************************************************************
        // FUNCTION:    verifyTypeAheadData
        // PARAMETERS:  codeType (the history code type ["region" / "sub-region" / "destination" / "resort"])
        //              codeID (the interface ID associated with the type ["4" / "RE47" / etc...])
        // DESCRIPTION: This function verifies an individual set of code data to ensure it is still valid
        // **************************************************************************************************************
        var verifyTypeAheadData = function(codeType, codeID) {

            var searchableData = (codeType === 'resort') ? typeAheadData.resorts : typeAheadData.destinations;
            var foundItem      = '';

            $.each(searchableData, function(index, item) {

                if (item.typeID === codeType && item.interfaceID === codeID) {

                    foundItem = item;
                    return false;
                }
            });

            return foundItem;
        };

        // **************************************************************************************************************
        // FUNCTION:    updateTypeAheadHistory
        // PARAMETERS:  newItem (the string code containing the Type and ID of the type ahead search item [i.e. "region:2" / "sub-region:34" / "destination:242" / "resort:RE97"])
        // DESCRIPTION: This function handles updating the working type ahead history array and associated browser cookie
        // **************************************************************************************************************
        var updateTypeAheadHistory = function(newItem) {

            if ($.inArray(newItem, typeAheadHistory) === -1) {

                typeAheadHistory.unshift(newItem);
                typeAheadHistory = typeAheadHistory.slice(0, 9);
                Cookies.set('afvcSearchHistory', typeAheadHistory, { expires: 604800 });
            }
        }

        // **************************************************************************************************************
        // FUNCTION:    openTypeAheadModal
        // PARAMETERS:  none
        // DESCRIPTION: This function handles opening the destinations type ahead modal container
        // **************************************************************************************************************
        var openTypeAheadModal = function() {

            var openedModal = false;

            if ($('.destinations-type-ahead-container').is(':hidden')) {

                $buttonControls.each(function() {

                    $(this).removeClass('current');
                    $(this).removeClass('current-no-toggle');
                });

                $('.btn-destination-primary').addClass('current-no-toggle');

                closeAllFilterSets($('.destinations-type-ahead-container'));

                openedModal = true;
            }

            return openedModal;
        };

        // **************************************************************************************************************
        // FUNCTION:    searchByTypeAheadSelection
        // PARAMETERS:  typeID (the type of control to be checked against ['region' / 'sub-region' / 'destination'])
        //              interfaceID (the appropriate ID attached to the specific type, used for determing which control in the interface to select)
        // DESCRIPTION: This function handles triggering the correct destination interface control based on the selected type ahead modal option
        // **************************************************************************************************************
        var searchByTypeAheadSelection = function(typeID, interfaceID) {

            var historyID = typeID + ':' + interfaceID;
            updateTypeAheadHistory(historyID);

            if (typeID !== 'resort') {

                if (checkAllControlsDisabled(typeID, interfaceID)) {

                    clearSecondaryFilters(false);
                    clearTravelDates(false);
                }

                clearDestinationFilters(false);

                if (typeID === 'region') {

                    $container.find('.js-region-container[data-region-id="' + interfaceID + '"]').find('.js-check-all').trigger('click');
                }
                else if (typeID === 'sub-region') {

                    $container.find('.js-sub-region-container[data-sub-region-id="' + interfaceID + '"]').find('.js-check-all').trigger('click');
                }
                else if (typeID === 'destination') {

                    $container.find('.js-destination[data-destination-id="' + interfaceID + '"]').trigger('click');
                }

                openTypeAheadModal();
            }
            else {

                toggleLoading('on');
                window.location = '/search-resorts/resort/' + interfaceID;
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             MAJOR SEARCH FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    performFacetedSearch
        // PARAMETERS:  fieldName (the input "name" of the field invoking the new search, to be used for reference in case of errors)
        // DESCRIPTION: This function handles building out the proper variables to be passed to the application to perform a faceted search
        // **************************************************************************************************************
        var performFacetedSearch = function(fieldName) {

            // We want the fieldName of the item selected passed in here incase of search error (zero results), so we can uncheck that item and gray it out
            // We can also provide a more descriptive error to the user in this scenario

            lastFieldName = fieldName;

            toggleLoading('on');

            // Reset any existing error messaging
            $('.js-error-message').hide();
            $('.js-error-message').empty();

            var moreResults         = false;
            var selections          = [];
            selections.destinations = $container.find('.js-destination:checked').toArray();
            selections.sale         = $container.find('.js-sale:checked').toArray();
            selections.redemption   = $container.find('.js-redemption:checked').toArray();
            selections.pricetype    = $container.find('.js-pricetype:checked').toArray();
            selections.allinclusive = $container.find('.js-allinclusive:checked').toArray();
            selections.price        = $container.find('.js-price:checked').toArray();
            selections.rating       = $container.find('.js-rating:checked').toArray();
            selections.bedroom      = $container.find('.js-bedroom:checked').toArray();
            selections.occupancy    = $container.find('.js-occupancy:checked').toArray();
            selections.option       = $container.find('.js-option:checked').toArray();
            selections.kitchen      = $container.find('.js-kitchen:checked').toArray();
            selections.amenity      = $container.find('.js-amenity:checked').toArray();
            selections.activity     = $container.find('.js-activity:checked').toArray();

            var completeURL         = '';
            var destinationURL      = buildFilterSegmentURL(selections.destinations, 'destinations');
            var saleURL             = buildFilterSegmentURL(selections.sale, 'sale');
            var redemptionURL       = buildFilterSegmentURL(selections.redemption, 'redemption');
            var priceTypeURL        = buildFilterSegmentURL(selections.pricetype, 'price-types');
            var allInclusiveURL     = buildFilterSegmentURL(selections.allinclusive, 'all-inclusive');
            var priceRangeURL       = buildFilterSegmentURL(selections.price, 'price-ranges');
            var ratingURL           = buildFilterSegmentURL(selections.rating, 'ratings');
            var bedroomTypeURL      = buildFilterSegmentURL(selections.bedroom, 'bedroom-types');
            var occupancyURL        = buildFilterSegmentURL(selections.occupancy, 'occupancy');
            var optionURL           = buildFilterSegmentURL(selections.option, 'options');
            var kitchenTypeURL      = buildFilterSegmentURL(selections.kitchen, 'kitchen-types');
            var amenityURL          = buildFilterSegmentURL(selections.amenity, 'amenities');
            var activityURL         = buildFilterSegmentURL(selections.activity, 'activities');

            var travelDatesURL = '';

            if (appliedStartDate !== '' && appliedEndDate !== '') {

                travelDatesURL = '/travel-dates/' + appliedStartDate + '-through-' + appliedEndDate;
            }

            var auxURL = '';

            if (searchType === 'search-results') {

                var hideAiSlider = $container.find('.js-slider-hide-ai');
                var hideAiValue  = (hideAiSlider.is(':checked')) ? hideAiSlider.val() : '';

                if (hideAiValue !== '') {

                    auxURL = '/aux/' + hideAiValue;
                }
            }

            var sortURL = '';

            if (searchType === 'search-results') {

                var sortValue = $sortFilter.val();

                if ($secondaryControlsContainer.is(':visible') && sortValue !== '' && sortValue !== 'default') {

                    sortURL = '/sort/' + sortValue;
                }
            }

            var pagesURL = '';

            if (searchType === 'search-results') {

                if (fieldName === 'more-results') {

                    currentResortPage++;
                    moreResults = true;
                    pagesURL    = '/page/' + currentResortPage;
                }
                else {

                    currentResortPage = 1;
                }
            }

            completeURL = destinationURL + travelDatesURL + saleURL + redemptionURL + priceTypeURL + allInclusiveURL + priceRangeURL + ratingURL + bedroomTypeURL + occupancyURL + optionURL + kitchenTypeURL + amenityURL + activityURL;

            if (completeURL !== '') {

                // The user has submitted the search process form with at least one selection
                completeURL = '/search-resorts/results' + completeURL + auxURL + sortURL + pagesURL;
            }
            else {

                // The user has submitted the search process form with nothing selected, which means we should default back to the "Search Resorts" SEO page setup
                completeURL = '/search-resorts';
            }

            if (searchType === 'search-results') {

                if (completeURL in historyStateLog) {

                    // The state we are looking for exists in the history state log, so use that cached data instead of performing an AJAX search

                    var dataJSON      = historyStateLog[completeURL];
                    currentResortPage = dataJSON.currentPage;
                    updateSearchInterface(dataJSON, false, false);

                    if (moreResults) {

                        history.replaceState({id: completeURL}, '', completeURL);
                    }
                    else {

                        history.pushState({id: completeURL}, '', completeURL);
                    }
                }
                else {

                    if (isSearchThrottled) {

                        setTimeout(function() {

                            facetedSearchAJAX(completeURL, moreResults, fieldName);

                        }, getThrottleDelay());
                    }
                    else {

                        facetedSearchAJAX(completeURL, moreResults, fieldName);
                    }
                }
            }
            else {

                window.location = completeURL;
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    facetedSearchAJAX
        // PARAMETERS:  completeURL (the full URL that the user is attempting to search on)
        //              moreResults (a boolean value that determines if we are searching a "new" set of results, or "more" results from an existing search)
        //              fieldName (the input "name" of the field invoking the new search, to be used for reference in case of errors)
        // DESCRIPTION: This function handles performing the AJAX call to the server to retrieve a set of JSON response results for the search criteria
        // **************************************************************************************************************
        var facetedSearchAJAX = function (completeURL, moreResults, fieldName) {

            $.ajax({
                method: "POST",
                url: "/h/search/PerformFacetedSearch",
                data: { searchURL: completeURL, searchPage: currentResortPage }
            })
                .done(function( data ) {

                    var dataJSON = JSON.parse(data);

                    if (dataJSON !== '') {

                        updateSearchThrottle(dataJSON.searchThrottle);

                        displayPerformanceMetrics(dataJSON.performanceMetrics);

                        if (dataJSON.type === 'no-results' || dataJSON.type === 'error') {

                            revertForNoResults(fieldName, dataJSON.type);
                        }
                        else {

                            updateSearchInterface(dataJSON, moreResults, false).done(function() {

                                // If this search has not been previously done this session, add it to the historyStateLog which will keep it as a running cache of the users front end searches
                                // This is used for both popping between states with the forward and back button for instant results, as well as if the user re-searches something they have already
                                // searched, thus saving processing time on the server side

                                if (!(completeURL in historyStateLog)) {

                                    // If this was a "moreResults" list search, then we need to override the results history data with the entire "list" of results
                                    // This is so when we pull this history log entry, it will properly do a full refresh of the result set rather than only displaying the most recent "resortsPerPage" number of resorts

                                    if (moreResults && dataJSON.type === 'list') {

                                        dataJSON.results = $searchResultsContainer.html().trim();
                                        dataJSON.mapData = googleMapData;
                                    }

                                    historyStateLog[completeURL] = dataJSON;
                                }
                            });

                            if (moreResults) {

                                history.replaceState({id: completeURL}, '', completeURL);
                            }
                            else {

                                history.pushState({id: completeURL}, '', completeURL);
                            }

                            lastCompleteURL = completeURL;

                            if (!disableTracking) {

                                ga('send', 'pageview', completeURL);
                            }
                        }
                    }
                });
        };

        // **************************************************************************************************************
        // FUNCTION:    performMapSearch
        // PARAMETERS:  none
        // DESCRIPTION: This function handles performing the AJAX call to the server to retrieve a set of JSON response results for searching a map area
        // **************************************************************************************************************
        var performMapSearch = function () {

            toggleLoading('on');

            // Reset any existing error messaging
            $('.js-error-message').hide();
            $('.js-error-message').empty();

            // Obtain the google map viewport box boundary points
            // Google only allows bound acquisition by South-West and North-East corners, so utilize these longitude (x) and latitude(y)
            // values to build the North-West (mapBoxTL) and South-East (mapBoxBR) corners for our bounding box comparison mathematics formula
            var mapBoxTLx = map.getBounds().getSouthWest().lng();
            var mapBoxTLy = map.getBounds().getNorthEast().lat();
            var mapBoxBRx = map.getBounds().getNorthEast().lng();
            var mapBoxBRy = map.getBounds().getSouthWest().lat();

            var selections          = [];
            selections.destinations = $container.find('.js-destination:checked').toArray();
            selections.sale         = $container.find('.js-sale:checked').toArray();
            selections.redemption   = $container.find('.js-redemption:checked').toArray();
            selections.pricetype    = $container.find('.js-pricetype:checked').toArray();
            selections.allinclusive = $container.find('.js-allinclusive:checked').toArray();
            selections.price        = $container.find('.js-price:checked').toArray();
            selections.rating       = $container.find('.js-rating:checked').toArray();
            selections.bedroom      = $container.find('.js-bedroom:checked').toArray();
            selections.occupancy    = $container.find('.js-occupancy:checked').toArray();
            selections.option       = $container.find('.js-option:checked').toArray();
            selections.kitchen      = $container.find('.js-kitchen:checked').toArray();
            selections.amenity      = $container.find('.js-amenity:checked').toArray();
            selections.activity     = $container.find('.js-activity:checked').toArray();

            var completeURL         = '';
            var destinationURL      = buildFilterSegmentURL(selections.destinations, 'destinations');
            var saleURL             = buildFilterSegmentURL(selections.sale, 'sale');
            var redemptionURL       = buildFilterSegmentURL(selections.redemption, 'redemption');
            var priceTypeURL        = buildFilterSegmentURL(selections.pricetype, 'price-types');
            var allInclusiveURL     = buildFilterSegmentURL(selections.allinclusive, 'all-inclusive');
            var priceRangeURL       = buildFilterSegmentURL(selections.price, 'price-ranges');
            var ratingURL           = buildFilterSegmentURL(selections.rating, 'ratings');
            var bedroomTypeURL      = buildFilterSegmentURL(selections.bedroom, 'bedroom-types');
            var occupancyURL        = buildFilterSegmentURL(selections.occupancy, 'occupancy');
            var optionURL           = buildFilterSegmentURL(selections.option, 'options');
            var kitchenTypeURL      = buildFilterSegmentURL(selections.kitchen, 'kitchen-types');
            var amenityURL          = buildFilterSegmentURL(selections.amenity, 'amenities');
            var activityURL         = buildFilterSegmentURL(selections.activity, 'activities');

            var travelDatesURL = '';

            if (appliedStartDate !== '' && appliedEndDate !== '') {

                travelDatesURL = '/travel-dates/' + appliedStartDate + '-through-' + appliedEndDate;
            }

            var auxURL       = '';
            var hideAiSlider = $container.find('.js-slider-hide-ai');
            var hideAiValue  = (hideAiSlider.is(':checked')) ? hideAiSlider.val() : '';

            if (hideAiValue !== '') {

                auxURL = '/aux/' + hideAiValue;
            }

            var sortURL   = '';
            var sortValue = $sortFilter.val();

            if ($secondaryControlsContainer.is(':visible') && sortValue !== '' && sortValue !== 'default') {

                sortURL = '/sort/' + sortValue;
            }

            completeURL = travelDatesURL + saleURL + redemptionURL + priceTypeURL + allInclusiveURL + priceRangeURL + ratingURL + bedroomTypeURL + occupancyURL + optionURL + kitchenTypeURL + amenityURL + activityURL + auxURL + sortURL;

            if (isSearchThrottled) {

                setTimeout(function() {

                    facetedSearchMapAJAX(completeURL, destinationURL, mapBoxTLx, mapBoxTLy, mapBoxBRx, mapBoxBRy);

                }, getThrottleDelay());
            }
            else {

                facetedSearchMapAJAX(completeURL, destinationURL, mapBoxTLx, mapBoxTLy, mapBoxBRx, mapBoxBRy);
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    facetedSearchMapAJAX
        // PARAMETERS:  completeURL (the full URL that the user is attempting to search on)
        //              destinationURL (the current destination URL before the search has been modified)
        //              mapBoxXYZ (the bounds of the current map view in latitude and longitude that need to be used for searching)
        // DESCRIPTION: This function handles performing the AJAX call to the server to retrieve a set of JSON response results for the search criteria
        // **************************************************************************************************************
        var facetedSearchMapAJAX = function (completeURL, destinationURL, mapBoxTLx, mapBoxTLy, mapBoxBRx, mapBoxBRy) {

            $.ajax({
                method: "POST",
                url: "/h/search/PerformMapSearch",
                data: { existingSearchURL: completeURL, existingDestinationsURL: destinationURL, mapTLx: mapBoxTLx, mapTLy: mapBoxTLy, mapBRx: mapBoxBRx, mapBRy: mapBoxBRy }
            })
            .done(function( data ) {

                var dataJSON = JSON.parse(data);

                if (dataJSON !== '') {

                    // COMMENTED OUT THESE FUNCTIONS TENTATIVELY AS THESE ARE NOT NECESSARY FOR THIS TYPE OF SEARCH AND CURRENTLY VARIABLES ARE MISSING TO MAKE THEM WORK
                    //updateSearchThrottle(dataJSON.searchThrottle);
                    //displayPerformanceMetrics(dataJSON.performanceMetrics);

                    if (dataJSON.type === 'map-no-change' || dataJSON.type === 'map-no-destinations' || dataJSON.type === 'no-results' || dataJSON.type === 'error') {

                        var errorMessage = '';

                        switch (dataJSON.type) {

                            case 'map-no-change':

                                // The requested map search is the same as the user's current search parameters
                                errorMessage = "We can't find any additional vacations that match your Map Search Area, so for now, we've kept your search the same.";
                                break;

                            case 'error':

                                // The requested map search encountered a search verification error
                                errorMessage = "An error occurred while attempting to process your Map Search Area. Please try again.";
                                break;

                            default:

                                // The requested map search has no resort results (no destinations from map search OR no results from a valid search)
                                errorMessage = "We can't find a vacation that matches your Map Search Area, so for now, we've kept your search the same.";
                        }

                        // Display the fixed modal error message
                        $('.js-error-message').html(errorMessage);
                        $('.js-error-message').slideDown($.extend({}, animationParameters));
                        toggleLoading('off');
                    }
                    else {

                        // The requested map search returned a new resort result set
                        currentResortPage = 1;

                        // Set the "completeURL" variable to the new search URL that was computed after running the map search
                        completeURL = dataJSON.newSearchURL;

                        // Reset the destinations section
                        // These will then be re-applied appropriately during the popstate trigger when the filter controls are updated
                        $('.js-region-control').removeClass('selected region-open sub-region-open');
                        $('.js-sub-region-control').removeClass('selected');
                        $('.js-region-container').hide();
                        $('.js-sub-region-container').hide();

                        openFirstAvailableRegion();

                        $('.btn-destination').removeClass('selected');

                        updateSearchInterface(dataJSON, false, true).done(function() {

                            // Enable the destination primary and reset buttons
                            // This must be done manually, as the normal search update process does not trigger these (they are part of the destination facet selection click event)
                            $('.btn-destination').addClass('selected');
                            toggleResetButton('destinations', 'on');

                            // If this search has not been previously done this session, add it to the historyStateLog which will keep it as a running cache of the users front end searches
                            // This is used for both popping between states with the forward and back button for instant results, as well as if the user re-searches something they have already
                            // searched, thus saving processing time on the server side
                            if (!(completeURL in historyStateLog)) {

                                historyStateLog[completeURL] = dataJSON;
                            }
                        });

                        history.pushState({id: completeURL}, '', completeURL);
                        lastCompleteURL = completeURL;

                        if (!disableTracking) {

                            ga('send', 'pageview', completeURL);
                        }
                    }
                }
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    performResortAvailabilitySearch
        // PARAMETERS:  resortID
        // DESCRIPTION: This function handles obtaining inventory for a specified resort ID to display in a modal window
        // **************************************************************************************************************
        var performResortAvailabilitySearch = function(resortID) {

            $('body').addClass('loading-body-overlay');
            toggleLoading('on');

            var selections        = [];
            selections.sale       = $container.find('.js-sale:checked').toArray();
            selections.redemption = $container.find('.js-redemption:checked').toArray();
            selections.pricetype  = $container.find('.js-pricetype:checked').toArray();
            selections.price      = $container.find('.js-price:checked').toArray();
            selections.bedroom    = $container.find('.js-bedroom:checked').toArray();
            selections.occupancy  = $container.find('.js-occupancy:checked').toArray();
            selections.kitchen    = $container.find('.js-kitchen:checked').toArray();

            var completeURL       = '';
            var saleURL           = buildFilterSegmentURL(selections.sale, 'sale');
            var redemptionURL     = buildFilterSegmentURL(selections.redemption, 'redemption');
            var priceTypeURL      = buildFilterSegmentURL(selections.pricetype, 'price-types');
            var priceRangeURL     = buildFilterSegmentURL(selections.price, 'price-ranges');
            var bedroomTypeURL    = buildFilterSegmentURL(selections.bedroom, 'bedroom-types');
            var occupancyURL      = buildFilterSegmentURL(selections.occupancy, 'occupancy');
            var kitchenTypeURL    = buildFilterSegmentURL(selections.kitchen, 'kitchen-types');

            var travelDatesURL = '';

            if (appliedStartDate !== '' && appliedEndDate !== '') {

                travelDatesURL = '/travel-dates/' + appliedStartDate + '-through-' + appliedEndDate;
            }

            completeURL = travelDatesURL + saleURL + redemptionURL + priceTypeURL + priceRangeURL + bedroomTypeURL + occupancyURL + kitchenTypeURL;

            $.ajax({
                method: "POST",
                url: "/h/resort/PerformResortAvailabilitySearch",
                data: { resortid: resortID, searchURL: completeURL }
            })
                .done(function( data ) {

                    var dataJSON = JSON.parse(data);

                    if (dataJSON !== '') {

                        if (dataJSON.type === 'no-results' || dataJSON.type === 'error') {

                            toggleLoading('off');
                            $('body').removeClass('loading-body-overlay');

                            // Display the fixed modal error message
                            $('.js-error-message').html('We can\'t find any available dates for the resort you selected that match your search. The resort may have recently sold out matching availability. See the resort page for more details.');
                            $('.js-error-message').slideDown($.extend({}, animationParameters));
                        }
                        else {

                            // Obtain the existing list card data from the interface and re-utilize the markup for the availability modal

                            var listCardMarkup = $( $('.resort-list-card[data-resort-id="' + resortID + '"]').html() );
                            listCardMarkup.find('.resort-secondary-container').remove();
                            listCardMarkup.find('.available-dates-container').remove();
                            listCardMarkup.find('.map-locator').remove();

                            var pricingContainer = listCardMarkup.find('.primary-resort-data .pricing-information').detach();
                            var controlContainer = listCardMarkup.find('.primary-resort-data .control-container').detach();

                            // Disable the Resort Fees and Local Fees Modal link, if present, by removing the "on click" hook class.
                            pricingContainer.find('.includes-resort-fees-label .resort-fees').removeClass('js-resort-fees');
                            pricingContainer.find('.local-fees-apply-label .local-fees').removeClass('js-local-fees');

                            listCardMarkup.find('.resort-data-container').append( $('<div class="secondary-information"></div>') );
                            listCardMarkup.find('.secondary-information').append(pricingContainer);
                            listCardMarkup.find('.secondary-information').append(controlContainer);

                            var modalHTML = '<div class="resort-availability-modal"><div class="resort-availability-modal-header">Availability</div><div class="resort-overview">' + listCardMarkup.prop('outerHTML') + '</div>' + dataJSON.availabilityHTML + '</div>';

                            toggleLoading('off');
                            $('body').removeClass('loading-body-overlay');

                            $.magnificPopup.open({
                                items: { src: modalHTML, type: 'inline' },
                                mainClass: 'mfp-fade',
                                tClose: 'Close'
                            });
                        }
                    }
                    else {

                        toggleLoading('off');
                        $('body').removeClass('loading-body-overlay');

                        // Display the fixed modal error message
                        $('.js-error-message').html('An error has occurred. Please try again.');
                        $('.js-error-message').slideDown($.extend({}, animationParameters));
                    }
                });
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                           INTERFACE UPDATE FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    updateSearchInterface
        // PARAMETERS:  dataJSON (the full URL that the user is attempting to search on)
        //              moreResults (a boolean value that determines if we are searching a "new" set of results, or "more" results from an existing search)
        //              popstateEnabled (a boolean value that determines if we want to trigger any specific "popstate" event code)
        // DESCRIPTION: This function handles updating the entire search interface after an AJAX search.
        //              Here we want smooth transitions and a nice user experience, as the user is creating new searches and processing time is required on the server side
        // **************************************************************************************************************
        var updateSearchInterface = function(dataJSON, moreResults, popstateEnabled) {

            // This function makes use of a "Deffered" state so that callbacks performed during the "facetedSearchAJAX" and "performMapSearch" functions can store
            // data properly after all animations have completed (which effects opacity and visiblity of stored HTML blocks in the "historyStateLog")
            var deferred = $.Deferred();

            if (dataJSON.type === 'static') {

                // Flush out existing mapData
                clearMarkersAndBounds();
                googleMapData = '';

                // Flush out existing list card events
                clearListCardEvents();

                // Update all filter control checkboxes
                updateFilterControls(dataJSON.filters, false);

                updateResortCount('0');
                updateBackToTopControl();

                // Update the state of every Check All button
                updateAllCheckSubRegionButtons();
                updateAllCheckRegionButtons();

                if ($hybridSearchContainer.is(':visible')) {

                    // Hybrid Search Mode is currently displaying, switch to Static Content Mode

                    activateResultScroll();

                    $hybridSearchContainer.fadeOut($.extend({}, animationParameters, {
                        complete: function() {

                            $staticContentContainer.html(dataJSON.results);
                            $staticContentContainer.fadeIn($.extend({}, animationParameters, {
                                complete: function() {

                                    // There is no featured content to display, if any currently exists, close it

                                    if (currentFeatureType !== '' && currentFeatureURLKey !== '') {

                                        closeFeaturedContent();
                                    }

                                    toggleLoading('off');
                                    deferred.resolve();
                                }
                            }));
                        }
                    }));
                }
                else {

                    // Static Content Mode is already displaying, just update the content

                    activateResultScroll();

                    $staticContentContainer.fadeOut($.extend({}, animationParameters, {
                        complete: function() {

                            $staticContentContainer.html(dataJSON.results);
                            $staticContentContainer.fadeIn($.extend({}, animationParameters, {
                                complete: function() {

                                    // There is no featured content to display, if any currently exists, close it

                                    if (currentFeatureType !== '' && currentFeatureURLKey !== '') {

                                        closeFeaturedContent();
                                    }

                                    toggleLoading('off');
                                    deferred.resolve();
                                }
                            }));
                        }
                    }));
                }
            }
            else if (dataJSON.type === 'list') {

                clearMarkersAndBounds();
                clearListCardEvents();

                if (moreResults) {

                    // Merge the current map data with the new subset of incoming data
                    $.merge(googleMapData, dataJSON.mapData);
                }
                else {

                    // Reset the current map data with the new subset of incoming data
                    googleMapData = dataJSON.mapData;
                }

                // Update all filter control checkboxes
                // When running a map search, we need to trigger a popstate for "updateFilterControls" so the destination buttons / labels will be updated
                // So this can be done by using the "popstateEnabled" boolean, which is always false except for when running map searches
                updateFilterControls(dataJSON.filters, popstateEnabled);
                updateResortCount(dataJSON.resortCount);
                updateBackToTopControl();

                // Update the state of every Check All button
                updateAllCheckSubRegionButtons();
                updateAllCheckRegionButtons();

                if ($staticContentContainer.is(':visible')) {

                    // Static Content Mode is currently displaying, switch to Hybrid Search Mode

                    $staticContentContainer.fadeOut($.extend({}, animationParameters, {
                        complete: function() {

                            $searchResultsContainer.html(dataJSON.results);
                            initializeMapView();
                            createListCardEvents();
                            $hybridSearchContainer.fadeIn($.extend({}, animationParameters, {
                                complete: function() {

                                    lazyLoadImages();
                                    activateResultScroll();
                                    updateFeaturedContent(dataJSON);
                                    toggleLoading('off');
                                    deferred.resolve();
                                }
                            }));
                        }
                    }));
                }
                else {

                    // Hybrid Search Mode is already displaying, just update the content

                    if (moreResults) {

                        // We already have the List View results displaying, we simply need to reset with new results

                        $searchResultsContainer.append(dataJSON.results);
                        initializeMapView();
                        createListCardEvents();
                        $searchResultsContainer.find('.resort-block-set').last().fadeIn($.extend({}, animationParameters, {
                            complete: function() {

                                lazyLoadImages();
                                updateFeaturedContent(dataJSON);
                                toggleLoading('off');
                                deferred.resolve();
                            }
                        }));
                    }
                    else {

                        // We are displaying a new set of results

                        activateResultScroll();
                        $searchResultsContainer.fadeOut($.extend({}, animationParameters, {
                            complete: function() {

                                $searchResultsContainer.html(dataJSON.results);
                                initializeMapView();
                                createListCardEvents();
                                $searchResultsContainer.fadeIn($.extend({}, animationParameters, {
                                    complete: function() {

                                        lazyLoadImages();
                                        updateFeaturedContent(dataJSON);
                                        toggleLoading('off');
                                        deferred.resolve();
                                    }
                                }));
                            }
                        }));
                    }
                }
            }

            // Set the "resetScrollPosition" back to false so that if we are in responsive mode, the interface will not attempt to scroll back to
            // a previous resulting list card, since a new result set has been loaded from performing a search or issuing a pop-state event
            resetScrollPosition = false;

            updateMetaData(dataJSON.metaTitle, dataJSON.metaDescription, dataJSON.metaCatalogueTag);
            updateDestinationDisplay();
            updateMoreFiltersDisplay();

            return deferred.promise();
        };

        // **************************************************************************************************************
        // FUNCTION:    revertSearchInterface
        // PARAMETERS:  dataJSON (the full URL that the user is attempting to search on)
        // DESCRIPTION: This function handles reverting the entire search interface after a popstate event, which needs to re-load previously cached front-end results.
        //              Here we want instantaneous re-loading of existing content that the user has already searched and we have cached on the front end
        // **************************************************************************************************************
        var revertSearchInterface = function(dataJSON) {

            if (dataJSON.type !== '') {

                // Initialize the "secondaryFilterCheck" and "destinationFilterCheck" variables so that we can re-use them when necessary
                var secondaryFilterCheck   = false;
                var destinationFilterCheck = false;

                // Reset all Buttons and Destination Sections
                $('.js-region-control').removeClass('selected region-open sub-region-open');
                $('.js-sub-region-control').removeClass('selected');
                $('.js-region-container').hide();
                $('.js-sub-region-container').hide();

                openFirstAvailableRegion();

                $buttonControls.removeClass('selected');
                $buttonControls.removeClass('current');
                $filterSections.removeClass('selected');
                $primaryFilterSets.hide();

                // Reset any existing error messaging
                $('.js-error-message').hide();
                $('.js-error-message').empty();

                if (dataJSON.type === 'static') {

                    // We are showing a static result set, and we need to remove the results and disable certain portions of the Search Process interface
                    updateFilterControls(dataJSON.filters, true);
                    updateResortCount('0');
                    updateBackToTopControl();
                    toggleResetButton('secondary', 'off');
                    toggleResetButton('destinations', 'off');

                    // Update the state of every Check All button
                    updateAllCheckSubRegionButtons();
                    updateAllCheckRegionButtons();

                    // Update Search Results content
                    $hybridSearchContainer.hide();
                    $staticContentContainer.html(dataJSON.results);
                    $staticContentContainer.show();

                    // There is no featured content to display, if any currently exists, close it
                    $featuredSearchContent.hide();
                    $featuredSearchContent.empty();
                    currentFeatureType   = '';
                    currentFeatureURLKey = '';

                    activateResultScroll();
                    toggleLoading('off');
                }
                else if (dataJSON.type === 'list') {

                    // Update all filter control checkboxes
                    updateFilterControls(dataJSON.filters, true);
                    updateResortCount(dataJSON.resortCount);
                    updateBackToTopControl();

                    // Update the state of every Check All button
                    updateAllCheckSubRegionButtons();
                    updateAllCheckRegionButtons();

                    // Determine if we have any active secondary filters, if so, show the Reset button, else hide it

                    secondaryFilterCheck = checkFilterSelections($secondaryFilterControls);

                    if (secondaryFilterCheck) {

                        toggleResetButton('secondary', 'on');
                    }
                    else {

                        toggleResetButton('secondary', 'off');
                    }

                    // Determine if we have any active destination filters, if so, show the Reset button, else hide it

                    destinationFilterCheck = checkDestinationFilters();

                    if (destinationFilterCheck) {

                        $('.btn-destination').addClass('selected');
                        toggleResetButton('destinations', 'on');
                    }
                    else {

                        toggleResetButton('destinations', 'off');
                    }

                    // Update Search Results content
                    $staticContentContainer.hide();
                    $searchResultsContainer.html(dataJSON.results);
                    $hybridSearchContainer.show();
                    lazyLoadImages();
                    clearMarkersAndBounds();
                    googleMapData = dataJSON.mapData;
                    clearListCardEvents();
                    initializeMapView();
                    createListCardEvents();

                    // Update any Featured Content if it exists

                    if (dataJSON.featuredType !== '' && dataJSON.featuredURLKey !== '' && dataJSON.featuredContent !== '') {

                        // We have Featured Content to display

                        $featuredSearchContent.css('display','block');
                        $featuredSearchContent.html(dataJSON.featuredContent);
                        resetFeaturedContentParameters(dataJSON.featuredType, dataJSON.featuredURLKey);
                    }
                    else {

                        // There is no Featured Content to display

                        $featuredSearchContent.hide();
                        $featuredSearchContent.empty();
                        currentFeatureType   = '';
                        currentFeatureURLKey = '';
                    }

                    activateResultScroll();
                    toggleLoading('off');
                }

                // Set the "resetScrollPosition" back to false so that if we are in responsive mode, the interface will not attempt to scroll back to
                // a previous resulting list card, since a new result set has been loaded from performing a search or issuing a pop-state event
                resetScrollPosition = false;

                updateMetaData(dataJSON.metaTitle, dataJSON.metaDescription, dataJSON.metaCatalogueTag);
                updateDestinationDisplay();
                updateMoreFiltersDisplay();
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    revertForNoResults
        // PARAMETERS:  fieldName (the input "name" of the field invoking the new search, to be used for reference in case of errors)
        //              type (the type of error that was encountered during the faceted search process)
        // DESCRIPTION: This function handles reverting the interface back to its previous search state after a failed search that returned "No Results", in order to
        //              prevent the user from getting a blank set of results
        // **************************************************************************************************************
        var revertForNoResults = function(fieldName, type) {

            var fieldMessage = ' ';

            if (fieldName !== 'bypass') {

                if (fieldName === 'check-all') {

                    fieldMessage = 'Check All';

                    // Due to an error occuring with the selection of multiple items (via a "Check All" destination button), we have to completely
                    // revert the search backwards to its last correct state

                    if (lastCompleteURL in historyStateLog) {

                        // The state we are looking for exists in the history state log, so use that cached data

                        var dataJSON      = historyStateLog[lastCompleteURL];
                        currentResortPage = dataJSON.currentPage;
                        revertSearchInterface(dataJSON);
                    }
                    else {

                        // The state we are looking for doesn't currently exist in the history state log, so we need to reload the page
                        // This type of event should never occur, but we want to account for it just incase of some weird behavior

                        window.location = location.pathname;
                    }
                }
                else if (fieldName === 'more-results') {

                    fieldMessage = 'View More';

                    // Revert the page count back to its previous number, and hide the View More control as it should no longer be applicable

                    currentResortPage--;
                    $('.view-more-results').hide();
                    $('.view-more-control').empty();
                    $('.view-more-message').show();
                }
                else if (fieldName === 'travel-dates') {

                    fieldMessage = ' Travel Dates: ' + appliedStartDate + '" through "' + appliedEndDate;

                    // Revert the applied travel date variables back to their previous values
                    appliedStartDate  = previousStartDate;
                    appliedEndDate    = previousEndDate;

                    // Revert the travel date inputs back to their previous values
                    $startDateControl.val(appliedStartDate);
                    $endDateControl.val(appliedEndDate);

                    var tempStartDate = appliedStartDate;
                    var tempEndDate   = appliedEndDate;
                    var activeRange   = true;

                    if (appliedStartDate === '' && appliedEndDate === '') {

                        tempStartDate = moment();
                        tempEndDate   = moment();
                        activeRange   = false;
                    }

                    // Revert the date range pickers back to their previous values
                    $desktopDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
                    $desktopDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);
                    $mobileDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
                    $mobileDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);

                    var updatedDisplay = '';

                    if (activeRange) {

                        updatedDisplay = (moment(tempStartDate, 'MM-DD-YYYY').format('MMM-DD-YY') + ' | ' + moment(tempEndDate, 'MM-DD-YYYY').format('MMM-DD-YY')).replace(/\./g, '');
                    }

                    $desktopDateRangePickerLabel.val(updatedDisplay);
                    $mobileDateRangePickerLabel.val(updatedDisplay);
                }
                else {

                    var selectedFilter = $('[name="' + fieldName + '"]');

                    if (selectedFilter.length) {

                        // Update the field messaging
                        fieldMessage = selectedFilter.next('.checkbox-label').html();

                        // Determine if we need to un-check or check the appropriate filter checkbox
                        // NOTE: The AI slider only hides results, therefore any non-result search caused be it must
                        // always be caused by checking, never unchecking, the filter slider

                        if (selectedFilter.prop("checked") || selectedFilter.hasClass('js-slider-hide-ai')) {

                            selectedFilter.prop("checked", false);
                        }
                        else {

                            selectedFilter.prop("checked", true);
                        }

                        // Check to see if we need to disable or enable the "Selected" state of any buttons / controls for this filter
                        if (selectedFilter.hasClass('js-destination')) {

                            // Update the state of the appropriate Check All button for this sub-region
                            var subRegionCheckAllButton = selectedFilter.closest('.js-sub-region-container').find('.js-check-all');
                            updateCheckSubRegionButton(subRegionCheckAllButton);

                            // Update the state of the appropriate Check All button for this region
                            var regionID             = selectedFilter.closest('.js-sub-region-container').data('region-id');
                            var regionCheckAllButton = $('.js-region-container[data-region-id="' + regionID + '"]').find('.js-check-all')
                            updateCheckRegionButton(regionCheckAllButton);

                            // Update the destination button controls relative to this item
                            updateDestinationControls(selectedFilter);
                        }
                        else {

                            // Only perform additional filter check logic for "Non-Auxiliary" filter checkboxes
                            // NOTE: This simply excludes further logic from being performed on any checkbox slider controls

                            if (!fieldName.startsWith('aux')) {

                                // Determine if we have any filter selections

                                var filterSection = selectedFilter.closest('.filter-set').data('filter-section');
                                var filterItems   = checkFilterSelections(selectedFilter.closest('.filter-set'));

                                if (filterItems) {

                                    $(filterSection).addClass('selected');
                                }
                                else {

                                    $(filterSection).removeClass('selected');
                                }
                            }
                        }
                    }
                }
            }

            // Determine if we have any active secondary filters, if so, show the Reset button, else hide it

            var secondaryFilterCheck = checkFilterSelections($secondaryFilterControls);

            if (secondaryFilterCheck) {

                toggleResetButton('secondary', 'on');
            }
            else {

                toggleResetButton('secondary', 'off');
            }

            // Determine if we have any active destination filters, if so, show the Reset button, else hide it

            var destinationFilterCheck = checkDestinationFilters();

            if (destinationFilterCheck) {

                toggleResetButton('destinations', 'on');
            }
            else {

                toggleResetButton('destinations', 'off');
            }

            if (type === 'error') {

                $('.js-error-message').html('An error has occured. Please try again.');
            }
            else {

                $('.js-error-message').html('Your most recent selection (' + fieldMessage + ') did not return any results. Please try another selection.');
            }

            // Display the fixed modal error message
            $('.js-error-message').slideDown($.extend({}, animationParameters));

            toggleLoading('off');
        };

        // **************************************************************************************************************
        // FUNCTION:    updateFilterControls
        // PARAMETERS:  filters (the array of data containing all filter types and their possible checkbox selections, and their states [disabled and/or checked])
        //              isPopstate (boolean value that determines if this function is being called from a popstate, and requires us to update Filter Buttons as well as Filter Controls)
        // DESCRIPTION: This function handles updating all filter control checkboxes to their new proper state after a the "performFacetedSearch" function
        //              has pulled a new set of search results
        // **************************************************************************************************************
        var updateFilterControls = function(filters, isPopstate) {

            var regionID    = '';
            var subRegionID = '';

            if (filters !== '') {

                // We have an updated set of filter controls, update them accordingly

                resetFilterControls($primaryControlsContainer);

                // Then disable any checkboxes that are no longer available
                $.each(filters, function(filterKeyType, filterSet) {

                    if (filterKeyType === 'traveldates') {

                        // Travel Dates filters (This only needs to be updated when we are reverting from a popstate event)

                        if (isPopstate) {

                            // Revert the applied travel date variables back to the historically stored values
                            appliedStartDate  = filterSet.startdate;
                            appliedEndDate    = filterSet.enddate;

                            // Revert the travel date inputs back to the historically stored values
                            $startDateControl.val(appliedStartDate);
                            $endDateControl.val(appliedEndDate);

                            var tempStartDate = appliedStartDate;
                            var tempEndDate   = appliedEndDate;
                            var activeRange   = true;

                            if (appliedStartDate === '' && appliedEndDate === '') {
                                tempStartDate = moment();
                                tempEndDate   = moment();
                                activeRange   = false;
                            }

                            // Revert the date range pickers back to the historically stored values
                            $desktopDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
                            $desktopDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);
                            $mobileDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
                            $mobileDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);

                            var updatedDisplay = '';

                            if (activeRange) {

                                updatedDisplay = (moment(tempStartDate, 'MM-DD-YYYY').format('MMM-DD-YY') + ' | ' + moment(tempEndDate, 'MM-DD-YYYY').format('MMM-DD-YY')).replace(/\./g, '');
                            }

                            $desktopDateRangePickerLabel.val(updatedDisplay);
                            $mobileDateRangePickerLabel.val(updatedDisplay);
                        }
                    }
                    else if (filterKeyType === 'sort') {

                        // Sort filter (This only needs to be updated when we are reverting from a popstate event)

                        if (isPopstate) {

                            var selectedOption = $('.js-sort').find(".custom-select-option[data-value='" + filterSet +"']");
                            $sortFilter.val(filterSet);

                            $('.js-sort').find('.custom-select-option').removeClass('selected');
                            selectedOption.addClass('selected');
                            $('.js-sort').removeClass('current');

                            if (filterSet !== 'default') {

                                $('.js-sort').find('.btn-custom-label').text(selectedOption.text());
                            }
                            else {

                                $('.js-sort').find('.btn-custom-label').text('Sort By');
                            }
                        }
                    }
                    else if (filterKeyType === 'aux') {

                        $.each(filterSet, function(key, value) {

                            var selectedFilter = $('[name="' + filterKeyType + '-' + value + '"]');

                            if (value === 'hide-ai') {

                                selectedFilter.prop('checked', true);
                            }
                        });
                    }
                    else {

                        if (filterKeyType !== 'page') {

                            // Checkbox filters

                            $.each(filterSet, function(key) {

                                if (this.isDisabled === 1 || this.isChecked === 1) {

                                    var selectedFilter = $('[name="' + filterKeyType + '-' + this.urlKey + '"]');

                                    if (this.isDisabled === 1) {

                                        selectedFilter.prop('disabled', true);
                                        selectedFilter.next('span').addClass('checkbox-label-disabled');

                                        if (filterKeyType === 'rating') {

                                            selectedFilter.next('img').addClass('checkbox-image-label-disabled');
                                            selectedFilter.parent().next('.tripadvisor-post-label').addClass('tripadvisor-label-disabled');
                                        }
                                    }

                                    if (this.isChecked === 1) {

                                        selectedFilter.prop('checked', true);

                                        if (isPopstate) {

                                            // We also need to update the filter buttons for this filter

                                            if (filterKeyType === 'destination') {

                                                // We also need to add some additional classes for the applicable Region and Sub-Region of the selection

                                                regionID    = selectedFilter.closest('.js-sub-region-container').data('region-id');
                                                subRegionID = selectedFilter.closest('.js-sub-region-container').data('sub-region-id');

                                                $('.js-region-control[data-region-id="' + regionID + '"]').addClass('selected');
                                                $('.js-sub-region-control[data-sub-region-id="' + subRegionID + '"]').addClass('selected');
                                            }

                                            // Enable the filter set control button
                                            $(selectedFilter.closest('.filter-set').data('button')).addClass('selected');
                                        }
                                    }
                                }
                            });
                        }
                    }
                });

                var hasEnabledDestinations = false;
                var hasEnabledSubRegions   = false;

                // Update Destination filters to disable any applicable Sub-Regions
                // We need to check all sub-regions before checking regions to ensure the disabled item logic works properly

                $('.js-sub-region-container').each(function() {

                    subRegionID = $(this).data('sub-region-id');

                    hasEnabledDestinations = checkDisabledFilters($(this), 'sub-region');
                    var subRegionControl   = $('.js-sub-region-control[data-sub-region-id="' + subRegionID + '"]');

                    if (hasEnabledDestinations) {

                        subRegionControl.removeClass('disabled-selector');
                    }
                    else {

                        subRegionControl.addClass('disabled-selector');

                        var subRegionContainer = $('.js-sub-region-container[data-sub-region-id="' + subRegionID + '"]');

                        // Check if this container was the one currently visible, and if so, hide it and default back to its associated region
                        // If a sub-region is a singular sub-region, and is also disabled at this point, then the region will also then be disabled,
                        // and the logic handling region containers below will ensure the next available region is displayed appropriately

                        if (subRegionContainer.is(':visible')) {

                            subRegionContainer.hide();

                            regionID = subRegionContainer.data('region-id');
                            $('.js-region-control[data-region-id="' + regionID + '"]').removeClass('sub-region-open').addClass('region-open');
                            $('.js-region-container[data-region-id="' + regionID + '"]').show();
                        }
                    }
                });

                // Update Destination filters to disable any applicable Regions
                // We need to check all regions after checking sub-regions to ensure the disabled item logic works properly

                $('.js-region-container').each(function(el) {

                    regionID = $(this).data('region-id');

                    hasEnabledSubRegions = checkDisabledFilters($(this), 'region');
                    var regionControl    = $('.js-region-control[data-region-id="' + regionID + '"]');

                    if (hasEnabledSubRegions) {

                        regionControl.removeClass('disabled-selector');
                    }
                    else {

                        regionControl.addClass('disabled-selector');

                        var regionContainer = $('.js-region-container[data-region-id="' + regionID + '"]');

                        // Check if this container was the one currently visible, and if so, hide it and default back to the next available region

                        if (regionContainer.is(':visible')) {

                            regionContainer.hide();
                            regionControl.removeClass('region-open sub-region-open');

                            openFirstAvailableRegion();
                        }
                    }
                });
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    updateDestinationControls
        // PARAMETERS:  filterSource (the parent element that contains the labels that need to be updated)
        // DESCRIPTION: This function handles refreshing the destination section labels with the appropriate highlights
        // **************************************************************************************************************
        var updateDestinationControls = function(filterSource) {

            var subRegionItems       = false;
            var regionItems          = false;
            var destinationItems     = false;
            var regionCheckAll       = false;

            var subRegionID          = '';
            var regionID             = '';
            var subRegionControls    = '';
            var selectedMobileFilter = '';

            if (filterSource.hasClass('js-check-all')) {

                var buttonType = filterSource.data('button-type');
                regionCheckAll = (buttonType === 'region') ? true : false;
            }

            if (regionCheckAll) {

                // This is a region specific Check-All button, so we need to check all sub-regions name labels

                filterSource.closest('.js-region-container').find('.js-sub-region-control').each(function() {

                    var subRegionControl   = $(this);
                    subRegionID            = subRegionControl.data('sub-region-id');
                    var subRegionContainer = $container.find('.js-sub-region-container[data-sub-region-id="' + subRegionID + '"]');
                    subRegionControls      = $('.js-sub-region-control[data-sub-region-id="' + subRegionID + '"]');

                    subRegionItems = checkFilterSelections(subRegionContainer);

                    if (subRegionItems) {

                        subRegionControls.addClass('selected');
                    }
                    else {

                        subRegionControls.removeClass('selected');
                    }
                });
            }
            else {

                // This is a destination checkbox or sub-region specific Check-All button, so we only need to check the relative sub-region name label

                subRegionItems = checkFilterSelections(filterSource.closest('.js-sub-region-container'));

                subRegionID       = filterSource.closest('.js-sub-region-container').data('sub-region-id');
                subRegionControls = $('.js-sub-region-control[data-sub-region-id="' + subRegionID + '"]');

                if (subRegionItems) {

                    subRegionControls.addClass('selected');
                }
                else {

                    subRegionControls.removeClass('selected');
                }
            }

            regionID         = filterSource.closest('.js-container').data('region-id');
            regionItems      = checkFilterSelections($container.find('.js-sub-region-container[data-region-id="' + regionID + '"]'));
            destinationItems = checkFilterSelections($container.find('.js-sub-region-container'));

            if (regionItems) {

                $('.js-region-control[data-region-id="' + regionID + '"]').addClass('selected');
            }
            else {

                $('.js-region-control[data-region-id="' + regionID + '"]').removeClass('selected');
            }

            if (destinationItems) {

                $('.btn-destination').addClass('selected');
            }
            else {

                $('.btn-destination').removeClass('selected');
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    updateDestinationDisplay
        // PARAMETERS:  none
        // DESCRIPTION: This function handles updating all destination label displays and the current search criteria in the type ahead modal
        // **************************************************************************************************************
        var updateDestinationDisplay = function() {

            var genericDisplay   = false;
            var buttonLabel      = '';
            var displayLabel     = '';
            var destinationCount = 0;
            var destinationID    = '';
            var regionsArray     = [];
            var subRegionsArray  = [];
            var matchType        = '';
            var matchID          = '';

            $container.find('.js-destination:checked').each(function() {

                destinationCount++;
                destinationID = $(this).data('destination-id');
                regionsArray.push($(this).closest('.js-sub-region-container').data('region-id'));
                subRegionsArray.push($(this).closest('.js-sub-region-container').data('sub-region-id'));
            });

            regionsArray    = removeDuplicates(regionsArray);
            subRegionsArray = removeDuplicates(subRegionsArray);

            if (destinationCount >= 1) {

                if (destinationCount === 1) {

                    matchType = 'destination';
                    matchID   = destinationID;
                }
                else {

                    if (regionsArray.length > 1) {

                        genericDisplay = true;
                    }
                    else {

                        var regionID          = regionsArray[0];
                        var regionContainer   = $container.find('.js-region-container[data-region-id="' + regionID + '"]');
                        var singularSubRegion = regionContainer.data('singular-sub-region');

                        if (singularSubRegion !== 'NA') {

                            // Determine if ALL destinations in this SINGULAR SUB-REGION are checked (Indicating a matching "Sub-Region Check All" selection)

                            if (checkAllFilterSelections($container.find('.js-sub-region-container[data-sub-region-id="' + singularSubRegion + '"]'))) {
                                matchType = 'sub-region';
                                matchID   = singularSubRegion;
                            }
                            else {
                                genericDisplay = true;
                            }
                        }
                        else {

                            if (subRegionsArray.length > 1) {

                                // Determine if ALL destinations in ALL sub-regions are checked (Indicating a matching "Region Check All" selection)

                                $container.find('.js-sub-region-container[data-region-id="' + regionID + '"]').each(function() {

                                    if (!checkAllFilterSelections($(this))) {

                                        genericDisplay = true;
                                        return false;
                                    }
                                });

                                if (!genericDisplay) {

                                    matchType = 'region';
                                    matchID   = regionID;
                                }
                            }
                            else {

                                // Determine if ALL destinations in this SUB-REGION are checked (Indicating a matching "Sub-Region Check All" selection)

                                var subRegionID = subRegionsArray[0];

                                if (checkAllFilterSelections($container.find('.js-sub-region-container[data-sub-region-id="' + subRegionID + '"]'))) {

                                    matchType = 'sub-region';
                                    matchID   = subRegionID;
                                }
                                else {

                                    genericDisplay = true;
                                }
                            }
                        }
                    }
                }

                if (genericDisplay) {

                    displayLabel = destinationCount + ' Destinations';
                    buttonLabel  = displayLabel;
                }
                else {

                    // Find the matching displayLabel data for the found selection in the
                    // Ensure that the matchID is converted to a string for proper object variable comparison
                    var dataMatch = verifyTypeAheadData(matchType, matchID.toString());

                    if (dataMatch !== '') {

                        label        = dataMatch.displayLabel;
                        postLabel    = (dataMatch.displayPostLabel !== '') ? ' <span class="post-label">(' + dataMatch.displayPostLabel + ')</span>' : '';
                        displayLabel = label + postLabel;
                        buttonLabel  = label;
                    }
                    else {

                        // If matching item is not found in the type ahead data (this should not ever happen, but just incase)
                        // Then as a failsafe, display the number of destinations selected

                        displayLabel = destinationCount + ' Destinations';
                        buttonLabel  = displayLabel;
                    }
                }

                $('.js-destination-label').val(buttonLabel);
                $('.js-current-search-criteria').html(displayLabel);
                $('.js-current-search-container').show();
            }
            else {

                // Reset the "Matches..." criteria in the type ahead modal interface

                $('.js-matches-criteria').find('.search-criteria').each(function() {

                    $(this).off('click');
                });

                $('.js-matches-criteria').html('');
                $('.js-typeahead-message-start').show();
                $('.js-typeahead-message-no-matches').hide();

                $('.js-destination-label').val('');
                $('.js-current-search-criteria').html('');
                $('.js-current-search-container').hide();
            }

            lastTypeAhead = $('.js-destination-type-ahead').val().toLowerCase();
        }

        // **************************************************************************************************************
        // FUNCTION:    updateDestinationControls
        // PARAMETERS:  none
        // DESCRIPTION: This function handles updating the display label for all of the "More Filters" buttons
        // **************************************************************************************************************
        var updateMoreFiltersDisplay = function() {

            var numFilters = countFilterSelections($secondaryFilterControls);

            if (numFilters >= 1) {

                $('.js-more-filters-label').html('Filters - ' + numFilters);
            }
            else {

                $('.js-more-filters-label').html('More Filters');
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                          RESETTING / CLEARING CONTROLS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:   toggleResetButton
        // PARAMETERS: sectionType (the section of the interface where we are toggling the applicable reset button)
        //             switchType (the switch to determine if we are displaying the Reset button, or hiding it)
        // DESCRIPTION: This function handles the display and hiding of the destinations and secondary filters reset buttons
        // **************************************************************************************************************
        var toggleResetButton = function(sectionType, switchType) {

            var filterSelections   = '';
            var filterCountClass   = '';
            var filterContentClass = '';
            var buttonClass        = '';

            if (sectionType === 'destinations') {

                filterSelections   = $destinationFilterControls;
                filterCountClass   = '.js-reset-destinations-count';
                filterContentClass = '.js-reset-destinations-content';
                containerClass     = '.js-reset-destinations-container';
            }
            else {

                filterSelections   = $secondaryFilterControls;
                filterCountClass   = '.js-reset-more-filters-count';
                filterContentClass = '.js-reset-more-filters-content';
                containerClass     = '.js-reset-more-filters-container';
            }

            if (switchType === 'on') {

                var selectedFilters = countFilterSelections(filterSelections);
                $(filterCountClass).html(selectedFilters);

                // Update the content for the word "filters" / "filter" or "destinations" / "destination" depending on the number of selections

                if (selectedFilters === 1) {

                    if (sectionType === 'destinations') {

                        $(filterContentClass).html('Destination');
                    }
                    else {

                        $(filterContentClass).html('Filter');
                    }
                }
                else {

                    if (sectionType === 'destinations') {

                        $(filterContentClass).html('Destinations');
                    }
                    else {

                        $(filterContentClass).html('Filters');
                    }
                }

                $(containerClass).show();
            }
            else {

                $(filterCountClass).html('0');
                $(containerClass).hide();
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    resetFilterControls
        // PARAMETERS:  resetSource (the source parent element that all child checkboxes need to be reset to "enabled" instead of "disabled")
        //              resetCheckedStatus (if this status is set to "true", that means we want to "uncheck" all child checkboxes of our "resetSource" as well)
        // DESCRIPTION: This function handles resetting all child checkbox elements of the "resetSource" element to "enabled" and  "unchecked"
        // **************************************************************************************************************
        var resetFilterControls = function(resetSource) {

            // Re-enable all checkboxes
            resetSource.find('.js-filter-checkbox').each(function() {

                $(this).prop('disabled', false);
                $(this).next('span').removeClass('checkbox-label-disabled');

                if ($(this).hasClass('js-rating')) {

                    $(this).next('img').removeClass('checkbox-image-label-disabled');
                    $(this).parent().next('.tripadvisor-post-label').removeClass('tripadvisor-label-disabled');
                }

                $(this).prop('checked', false);
            });

            // Reset all slider checkboxes
            resetSource.find('.js-slider-checkbox').each(function() {

                $(this).prop('disabled', false);
                $(this).prop('checked', false);
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    clearDestinationFilters
        // PARAMETERS:  runSearch (boolean value that decides whether a faceted search should be performed as part of this function call)
        // DESCRIPTION: This function handles the clearing of all destination filter checkboxes and (optionally) re-running the new faceted search without those options
        // **************************************************************************************************************
        var clearDestinationFilters = function(runSearch) {

            // Reset all filter checkboxes for both desktop and mobile
            $('.destination-filters').each(function() {

                resetFilterControls($(this));
            });

            updateAllCheckSubRegionButtons();
            updateAllCheckRegionButtons();

            // Reset all other destination related controls to their default state
            $('.js-region-control').removeClass('selected region-open sub-region-open');
            $('.js-sub-region-control').removeClass('selected');
            $('.js-region-container').hide();
            $('.js-sub-region-container').hide();

            openFirstAvailableRegion();

            if (runSearch) {

                toggleResetButton('destinations', 'off');
                $('.btn-destination').removeClass('selected');
                performFacetedSearch('bypass');
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    clearSecondaryFilters
        // PARAMETERS:  runSearch (boolean value that decides whether a faceted search should be performed as part of this function call)
        // DESCRIPTION: This function handles the clearing of all secondary filter checkboxes,
        //              and re-running the new faceted search without those options
        // **************************************************************************************************************
        var clearSecondaryFilters = function(runSearch) {

            // Reset all secondary filter checkboxes
            $('.secondary-filter-option-container').each(function() {

                resetFilterControls($(this));
            });

            // Reset all slider checkboxes
            $('.secondary-filter-controls').find('.js-slider-checkbox').each(function() {

                $(this).prop('disabled', false);
                $(this).prop('checked', false);
            });

            // Reset the secondary filter control button states
            $filterSections.each(function() {

                $(this).removeClass('selected');
            });

            toggleResetButton('secondary', 'off');

            if (runSearch) {

                performFacetedSearch('bypass');
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                                TOGGLE FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:   toggleMobileMenu
        // PARAMETERS: sectionType (the section of the interface we are toggling in the mobile menu)
        //             switchType (the switch to determine if we are displaying the menu, or hiding it)
        // DESCRIPTION: This function handles the display and hiding of the destinations and more filters mobile menus
        // **************************************************************************************************************
        var toggleMobileMenu = function(sectionType, switchType) {

            if (!isTransitioning) {

                if (switchType === 'off') {

                    // The new scroll position must be calculated before removing the container classes from the mobile menu
                    // Otherwise, the css transition animations cause the scroll offset to be computed incorrectly
                    var newScrollPosition = ((screenMode === 'responsive') && resetScrollPosition) ? lastScrollCard.offset().top - 124 : 0;

                    // Hide both mobile menu views, thus ensuring proper management of which view to display when toggling the mobile menu from different locations
                    $('.js-mobile-search').hide();
                    $('#js-mobile-menu-content').find('.navigation').hide();

                    $siteBodyContainer.removeClass('mobile-menu-open');
                    $mobileMenuOverlay.removeClass('js-search-overlay');

                    // The new scroll position must be applied after the mobile menu container classes have been removed
                    if ((screenMode === 'responsive') && resetScrollPosition) {

                        $('html, body').scrollTop(newScrollPosition);
                    }
                }
                else {

                    resetScrollPosition = false;

                    if (screenMode === 'responsive') {

                        var currentScroll   = $(document).scrollTop();
                        var headerContainer = $('.header-container');

                        // When enabling the mobile menu and the header container is in the viewport, then we do not want to
                        // perform a scroll reset to a list card position when closing the menu because the user is near the top of the page

                        if ((headerContainer.offset().top + headerContainer.outerHeight(true)) < currentScroll) {

                            // When enabling the mobile menu and list results are displayed, determine the top most viewable list card
                            // so the user may potentially be returned to that viewing point if no new search selections are made

                            var currentListCards = $('.resort-list-card');

                            if (currentListCards.length > 0) {

                                currentListCards.each(function() {

                                    if ($(this).offset().top >= currentScroll) {

                                        resetScrollPosition = true;
                                        lastScrollCard      = $(this);
                                        return false;
                                    }
                                });
                            }
                        }
                    }

                    // Hide / show the appropriate mobile menu views for this mobile menu toggle operation
                    $('.js-mobile-search').show();
                    $('#js-mobile-menu-content').find('.navigation').hide();

                    if (sectionType === 'destinations') {

                        $('.js-mobile-container-more-filters').hide();
                        $('.js-mobile-container-destinations').show();
                        $siteBodyContainer.addClass('mobile-menu-open');
                        $mobileMenuOverlay.addClass('js-search-overlay');
                    }
                    else if (sectionType === 'more-filters') {

                        $('.js-mobile-container-destinations').hide();
                        $('.js-mobile-container-more-filters').show();
                        $siteBodyContainer.addClass('mobile-menu-open');
                        $mobileMenuOverlay.addClass('js-search-overlay');
                    }
                }
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    toggleLoading
        // PARAMETERS:  count (the total number of resorts available in the current set of search results)
        // DESCRIPTION: This function handles toggling on and off for the "Loading" animations, and for enabling / disabling all controls during the "Loading" process
        // **************************************************************************************************************
        var toggleLoading = function(mode) {

            if (mode === 'on') {

                if (searchType === 'home-search' && lastFieldName === 'travel-dates') {

                    $('.banner-container-homepage').addClass('loading');
                }

                // Disable all Primary and Mobile Controls and Modal Windows
                $('.filters').addClass('loading');
                $('.mobile-menu-content-container').addClass('loading');
                $mobileContainer.addClass('loading');

                // Disable all Secondary Controls
                $('.js-sort').addClass('loading');
                $('.refresh-map-button').addClass('loading');

                // Hide the "View More" controls
                $('.view-more-control').hide();
                $('.view-more-message').hide();
                $('.view-more-results-container').addClass('loading');
            }
            else {

                if (searchType === 'home-search') {
                    $('.banner-container-homepage').removeClass('loading');
                }

                // Enable all Primary and Mobile Controls and Modal Windows
                $('.filters').removeClass('loading');
                $('.mobile-menu-content-container').removeClass('loading');
                $mobileContainer.removeClass('loading');

                // Enable all Secondary Controls
                $('.js-sort').removeClass('loading');
                $('.refresh-map-button').removeClass('loading');

                if ((currentResortPage * resortsPerPage) > currentResortCount) {

                    currentShowingCount = currentResortCount;
                }
                else {

                    currentShowingCount = currentResortPage * resortsPerPage;
                }

                if (currentShowingCount !== currentResortCount) {

                    $('.view-more-control').show();
                }
                else {

                    $('.view-more-message').show();
                }

                $('.view-more-results-container').removeClass('loading');

                // Try resetting the Facebook widget with the pages new URL
                try { FB.XFBML.parse(); } catch(ex) {}

                // Complete the transition by resetting the transition check parameters
                isTransitioning = false;
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    toggleFilter
        // PARAMETERS:  button (the button element being toggled)
        //              filter (the filter set associated with the toggled button)
        // DESCRIPTION: This function handles the toggling open and closed of a filter set when its control button is pressed
        // **************************************************************************************************************
        var toggleFilter = function(e, button, filter) {

            if (!isTransitioning) {

                // Ensure we stop click propagation from moving up further and hitting the click management
                // event that exists on the <html> DOM element of the page. Instead, manage all click related
                // events locally in this specific click event handler
                e.stopPropagation();

                isTransitioning = true;

                if (filter.is(':visible')) {

                    toggleButton(button, 'off');
                    closeFilterSet(filter);
                }
                else {

                    toggleButton(button, 'on');
                    closeAllFilterSets(filter);
                    $('.js-custom-button .btn-custom').removeClass('current');
                }
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    toggleButton
        // PARAMETERS:  button (the button element being toggled)
        //              toggleSwitch (the state of the button we are changing to, "on" or "off")
        // DESCRIPTION: This function handles the toggling on and off of a control button when it is pressed
        // **************************************************************************************************************
        var toggleButton = function(button, toggleSwitch) {

            $buttonControls.each(function() {

                $(this).removeClass('current');
                $(this).removeClass('current-no-toggle');
            });

            if (toggleSwitch !== 'off') {

                button.addClass('current');
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    openFilterSet
        // PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be opened)
        // DESCRIPTION: This function handles opening of the appropriate supplied filter
        // **************************************************************************************************************
        var openFilterSet = function(filter) {

            filter.show();
            isTransitioning = false;
        };

        // **************************************************************************************************************
        // FUNCTION:    closeFilterSet
        // PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be closed)
        // DESCRIPTION: This function handles closing of the appropriate supplied filter
        // **************************************************************************************************************
        var closeFilterSet = function(filter) {

            filter.hide();
            isTransitioning = false;
        };

        // **************************************************************************************************************
        // FUNCTION:    closeAllFilterSets
        // PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be opened)
        // DESCRIPTION: This function handles closing all potentially open filter sets, then opening the new appropriate filter
        // **************************************************************************************************************
        var closeAllFilterSets = function(filter) {

            $primaryFilterSets.each(function(el) {

                if ($(this).is(':visible')) { $(this).hide(); }
            });

            openFilterSet(filter);
        };

        // **************************************************************************************************************
        // FUNCTION:    openFirstAvailableRegion
        // PARAMETERS:  none
        // DESCRIPTION: This function handles opening the first available region control in the destinations interface
        // **************************************************************************************************************
        var openFirstAvailableRegion = function() {

            $('.js-region-control').removeClass('region-open sub-region-open');
            $('.js-region-container').hide();
            $('.js-sub-region-container').hide();

            // For the mobile interface, hide all view containers and re-open the region controls view container
            $('.js-mobile-destination-controls').hide();
            $('.js-mobile-region-controls-view').show();

            var firstRegion       = $container.find('.js-region-control').not('.disabled-selector').first();
            var regionID          = firstRegion.data('region-id');
            var regionContainer   = $container.find('.js-region-container[data-region-id="' + regionID + '"]');
            var singularSubRegion = regionContainer.data('singular-sub-region');

            firstRegion.addClass('region-open');

            if (singularSubRegion === 'NA') {

                // Open the Region Container for this control (multiple sub-regions exist)
                $container.find('.js-region-container[data-region-id="' + regionID + '"]').show();
            }
            else {

                // Open the singular Sub-Region Container for this control (only one sub-region exists, so skip the region container)
                $container.find('.js-sub-region-container[data-sub-region-id="' + singularSubRegion + '"]').show();
            }
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                          COUNTER / CHECKER FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    checkDisabledSelections
        // PARAMETERS:  filterSource (the checkbox element that is being clicked on [being "Checked" or "Unchecked"])
        //              resetSource (the source parent element that all child checkboxes need to be reset to "enabled" instead of "disabled")
        // DESCRIPTION: This function handles validating whether or not a checkbox has been de-selected, and is the last non-disabled checkbox selection being unchecked
        //              This is being validated because if it is the last applicable checkbox in its filter set (Checked and Enabled), and we have other checkboxes in
        //              the filter set that are non-applicable (Checked and Disabled, due to other overlapping facets causing that function to not be contributing to the results),
        //              then we need to make sure to reset all filters in that filter set back to their default state to prevent a zero results search from occurring
        // **************************************************************************************************************
        var checkDisabledSelections = function(filterSource, resetSource) {

            if (!filterSource.prop("checked")) {

                // We are unchecking a box, determine if this is the last non-disabled checked selection that is being unchecked
                var numberChecked         = resetSource.find('.js-filter-checkbox:checked').length;
                var numberCheckedDisabled = resetSource.find('.js-filter-checkbox:checked:disabled').length;

                if (numberChecked === numberCheckedDisabled && numberChecked > 0 && numberCheckedDisabled > 0) {

                    // We are unchecking the last applicable box (Checked and Enabled), and we have other non-applicable boxes
                    // We need to reset this filter to remove all checked options, otherwise we will get a zero result search
                    resetFilterControls(resetSource);

                    if (resetSource.hasClass('primary-destination-filters')) {

                        // Reset any region or sub-region names to their default state

                        $('.js-region-control').removeClass('selected');
                        $('.js-sub-region-control').removeClass('selected');
                    }
                }
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    checkFilterSelections
        // PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
        // DESCRIPTION: This function handles validating whether or not a checkbox in the "filterSource" is "checked". One checkbox being "checked" is sufficent for the whole set
        // **************************************************************************************************************
        var checkFilterSelections = function(filterSource) {

            var returnCheck = false;

            filterSource.find('.js-filter-checkbox').each(function() {

                if ($(this).prop('checked')) {

                    // Set the 'returnCheck' to true to indicate we have at least one selection within the filterSource subset
                    // Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 selection is sufficient)

                    returnCheck = true;
                    return false;
                }
            });

            return returnCheck;
        };

        // **************************************************************************************************************
        // FUNCTION:    checkAllFilterSelections
        // PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
        // DESCRIPTION: This function handles validating whether or not all checkboxes in the "filterSource" are "checked".
        // **************************************************************************************************************
        var checkAllFilterSelections = function(filterSource) {

            var returnCheck = true;

            filterSource.find('.js-filter-checkbox').each(function() {

                if (!$(this).prop('checked')) {

                    // Set the 'returnCheck' to false to indicate we have at least one selection within the filterSource subset that is unchecked
                    // Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 selection is sufficient)

                    returnCheck = false;
                    return false;
                }
            });

            return returnCheck;
        };

        // **************************************************************************************************************
        // FUNCTION:    checkAvailableFilterSelections
        // PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
        // DESCRIPTION: This function handles validating whether or not at least one checkbox in the "filterSource" are "enabled".
        // **************************************************************************************************************
        var checkAvailableFilterSelections = function(filterSource) {

            var returnCheck = false;

            filterSource.find('.js-filter-checkbox').each(function() {

                if (!$(this).prop('disabled')) {

                    // Set the 'returnCheck' to true to indicate we have at least one selection within the filterSource subset that is enabled
                    // Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 selection is sufficient)

                    returnCheck = true;
                    return false;
                }
            });

            return returnCheck;
        };

        // **************************************************************************************************************
        // FUNCTION:    checkDisabledFilters
        // PARAMETERS:  filterSource (the source element to originate the selection process)
        //              filterType (the type of selector being used ['region / 'sub-region'])
        // DESCRIPTION: This function handles determining if we have any filters currently enabled, which we use to determine if the filter section should be enabled or disabled
        // **************************************************************************************************************
        var checkDisabledFilters = function(filterSource, filterType) {

            var disabledFilterCheck = false;

            if (filterType === 'region') {

                filterSource.find('.js-sub-region-control').each(function() {

                    if (!$(this).hasClass('disabled-selector')) {

                        // Set "disabledFilterCheck" to true, because we found at least one enabled item, so we know we have selectable filter options
                        // Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 match is sufficient)

                        disabledFilterCheck = true;
                        return false;
                    }
                });
            }
            else {

                filterSource.find('.js-filter-checkbox').each(function() {

                    if (!$(this).prop("disabled")) {

                        // Set "disabledFilterCheck" to true, because we found at least one enabled item, so we know we have selectable filter options
                        // Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 match is sufficient)

                        disabledFilterCheck = true;
                        return false;
                    }
                });
            }

            return disabledFilterCheck;
        };

        // **************************************************************************************************************
        // FUNCTION:    checkDestinationFilters
        // PARAMETERS:  none
        // DESCRIPTION: This function handles determining if we have any destinations filters currently selected, which we use to determine if Map View should be enabled
        // **************************************************************************************************************
        var checkDestinationFilters = function() {

            var destinationFilterCheck = false;

            $('.primary-destination-filters').find('.js-destination-checkbox .js-filter-checkbox').each(function(el) {

                if ($(this).prop("checked")) {

                    // Set "destinationFilterCheck" to true, because we found at least one checked item, so we know we can enable the Map View option
                    // Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 match is sufficient)

                    destinationFilterCheck = true;
                    return false;
                }
            });

            return destinationFilterCheck;
        };

        // **************************************************************************************************************
        // FUNCTION:    countFilterSelections
        // PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
        // DESCRIPTION: This function handles counting the number of elements in the "filterSource" that are "checked"
        // **************************************************************************************************************
        var countFilterSelections = function(filterSource) {

            var count = 0;

            filterSource.find('.js-filter-checkbox').each(function() {

                if ($(this).prop('checked')) {

                    count++;
                }
            });

            return count;
        };

        // **************************************************************************************************************
        // FUNCTION:    checkAllControlsDisabled
        // PARAMETERS:  typeID (the type of control to be checked against ['region' / 'sub-region' / 'destination'])
        //              interfaceID (the appropriate ID attached to the specific type, used for determing which control in the interface to select)
        // DESCRIPTION: This function handles determining if all destination controls in a given type are disabled
        // **************************************************************************************************************
        var checkAllControlsDisabled = function (typeID, interfaceID) {

            var disabledCheck = false;

            if (typeID === 'region') {

                disabledCheck = !checkDisabledFilters($container.find('.js-region-container[data-region-id="' + interfaceID + '"]'), 'region');
            }
            else if (typeID === 'sub-region') {

                disabledCheck = !checkDisabledFilters($container.find('.js-sub-region-container[data-sub-region-id="' + interfaceID + '"]'), 'sub-region');
            }
            else if (typeID === 'destination') {

                disabledCheck = $container.find('.js-destination[data-destination-id="' + interfaceID + '"]').prop('disabled');
            }

            return disabledCheck;
        };

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                           FEATURED CONTENT FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    updateFeaturedContent
        // PARAMETERS:  dataJSON (the search results data returned from the "performFacetedSearch" function, which is in JSON format)
        // DESCRIPTION: This function handles the logic validation to determine what kind of featured SEO content currently exists,
        //              and then toggling it open or closed properly
        // **************************************************************************************************************
        var updateFeaturedContent = function(dataJSON) {

            // Turn ON Featured Content

            if (dataJSON.featuredType !== '' && dataJSON.featuredURLKey !== '' && dataJSON.featuredContent !== '') {

                // We have Featured Content to display

                if (currentFeatureType !== '' && currentFeatureURLKey !== '') {

                    // We have an existined Featured Content block already being displayed

                    if (dataJSON.featuredType !== currentFeatureType || dataJSON.featuredURLKey !== currentFeatureURLKey) {

                        // We have an existing Featured Content block that is different than the new content block
                        transitionFeaturedContent(dataJSON.featuredType, dataJSON.featuredURLKey, dataJSON.featuredContent);
                    }
                }
                else {

                    // We do not have an existing content block
                    openFeaturedContent(dataJSON.featuredType, dataJSON.featuredURLKey, dataJSON.featuredContent, 'slide');
                }
            }
            else {

                // There is no featured content to display, if any currently exists, close it

                if (currentFeatureType !== '' && currentFeatureURLKey !== '') {

                    closeFeaturedContent();
                }
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    transitionFeaturedContent
        // PARAMETERS:  featureType (the "type" of the featured content being used, to be stored for future faceting validation)
        //              featureKey (the "urlKey" of the featured content being used, to be stored for future faceting validation)
        //              featureContent (the SEO content to be loaded into the featured SEO content area)
        //              animationType (the type of animation we want to use when opening the new featured SEO content)
        // DESCRIPTION: This function handles the closing of the currently open featured SEO content area, and then and opening of the new featured SEO content area
        // **************************************************************************************************************
        var transitionFeaturedContent = function(featureType, featureKey, featureContent, animationType) {

            $featuredSearchContent.fadeOut($.extend({}, animationParameters, {
                complete: function() {

                    openFeaturedContent(featureType, featureKey, featureContent, 'fade');
                }
            }));
        };

        // **************************************************************************************************************
        // FUNCTION:    openFeaturedContent
        // PARAMETERS:  featureType (the "type" of the featured content being used, to be stored for future faceting validation)
        //              featureKey (the "urlKey" of the featured content being used, to be stored for future faceting validation)
        //              featureContent (the SEO content to be loaded into the featured SEO content area)
        //              animationType (the type of animation we want to use when opening the new featured SEO content)
        // DESCRIPTION: This function handles reloading new SEO content into, and opening of the featured SEO content area
        // **************************************************************************************************************
        var openFeaturedContent = function(featureType, featureKey, featureContent, animationType) {

            $('.site-container-search').removeClass('additional-padding-scenario');

            $featuredSearchContent.css('display', 'none');
            $featuredSearchContent.html(featureContent);

            if (animationType === 'fade') {

                $featuredSearchContent.fadeIn($.extend({}, animationParameters, {
                    complete: function() {

                        resetFeaturedContentParameters(featureType, featureKey);
                    }
                }));
            }
            else {

                $featuredSearchContent.slideDown($.extend({}, animationParameters, {
                    complete: function() {

                        resetFeaturedContentParameters(featureType, featureKey);
                    }
                }));
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    closeFeaturedContent
        // PARAMETERS:  none
        // DESCRIPTION: This function handles closing of the featured SEO content area
        // **************************************************************************************************************
        var closeFeaturedContent = function() {

            $('.site-container-search').addClass('additional-padding-scenario');

            $featuredSearchContent.slideUp($.extend({}, animationParameters, {
                complete: function() {

                    $featuredSearchContent.empty();
                    currentFeatureType   = '';
                    currentFeatureURLKey = '';
                }
            }));
        };

        // **************************************************************************************************************
        // FUNCTION:    resetFeaturedContentParameters
        // PARAMETERS:  featureType (the "type" of the featured content being used, to be stored for future faceting validation)
        //              featureKey (the "urlKey" of the featured content being used, to be stored for future faceting validation)
        // DESCRIPTION: This function handles resetting of the stored featured content variables, and resetting the featured SEO search content container in line styles
        // **************************************************************************************************************
        var resetFeaturedContentParameters = function(featureType, featureKey) {

            currentFeatureType   = featureType;
            currentFeatureURLKey = featureKey;
            $featuredSearchContent.css('overflow', '');
            $featuredSearchContent.css('height', '');

            configureFeaturedInfoDialogs();
        };

        // **************************************************************************************************************
        // FUNCTION:    resetFeaturedInfoDialogs
        // PARAMETERS:  none
        // DESCRIPTION: This function re-creating any necessary featured content click events for info dialogs (like activities disclaimers)
        // **************************************************************************************************************
        var configureFeaturedInfoDialogs = function() {

            var triggers = $('.featured-info-dialog');

            $(triggers).on("click", function() {

                var triggerEl    = this;
                var alertMessage = $(triggerEl).attr("data-alert-message");
                var message      = $(alertMessage).html();

                launchFeaturedInfoDialog(message);
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    launchFeaturedInfoDialog
        // PARAMETERS:  message (the content to display in the dialog)
        // DESCRIPTION: This function handles launches the informational dialog attached to featured content click events
        // **************************************************************************************************************
        var launchFeaturedInfoDialog = function(message) {

            if (message) {

                lDialog.open({
                    content: '<div>' + message + '</div>',
                    autofocusFirstFocusableElement: false
                });
            }
        }

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             MISCELLANEOUS FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

        // **************************************************************************************************************
        // FUNCTION:    buildFilterSegmentURL
        // PARAMETERS:  selectionSet (the set of checkbox options, in array format, that are "checked" for this specific segmentType)
        //              segmentType (the type, or category, of checkbox options that are being processed)
        // DESCRIPTION: This function builds out a url structure segment identical to what our search process router on the application looks for to determine
        //              whether or not a url is valid and contains properly formatted url keys for the segmentType selections in question
        // **************************************************************************************************************
        var buildFilterSegmentURL = function(selectionSet, segmentType) {

            var url = '';

            if (selectionSet.length > 0) {

                url = '/' + segmentType + '/XXXX';

                selectionSet.sort(function(a,b) {

                    var A = a.value.toLowerCase();
                    var B = b.value.toLowerCase();

                    if (A < B) {

                        return -1;
                    }
                    else if (A > B) {

                        return 1;
                    }
                    else {

                        return 0;
                    }
                });

                $.each(selectionSet, function(key, inputElement) {

                    url = url + '-and-' + $(inputElement).val();
                });

                url = url.replace('XXXX-and-','');
            }

            return url;
        };

        // **************************************************************************************************************
        // FUNCTION:    updateResortCount
        // PARAMETERS:  count (the total number of resorts available in the current set of search results)
        // DESCRIPTION: This function handles updating the total number of resorts available, the number of resorts currently showing in the result set,
        //              and the hiding / showing of the View More control
        // **************************************************************************************************************
        var updateResortCount = function(count) {

            var numResorts     = parseInt(count, 10);
            currentResortCount = numResorts;

            if ((currentResortPage * resortsPerPage) > currentResortCount) {

                currentShowingCount = currentResortCount;
            }
            else {

                currentShowingCount = currentResortPage * resortsPerPage;
            }

            // Update the View More control
            if (currentShowingCount !== currentResortCount) {

                $('.view-more-message').hide();
                $('.view-more-results').show();
                $('.view-more-control').html('1 - ' + currentShowingCount + ' of ' + currentResortCount + ' Resorts | Click to Show More');
            }
            else {

                $('.view-more-results').hide();
                $('.view-more-message').html('Currently Displaying All ' + currentResortCount + ' Resorts');
                $('.view-more-message').show();
                $('.view-more-control').empty();
            }

            // Update the paginated resort counter
            $('.js-paginated-resort-counter').html('1 - ' + currentShowingCount + ' of ' + currentResortCount);

            // Update the resort count number
            $('.js-resort-count').html(currentResortCount);

            // Update the content for the word "resorts" or "resort" depending on the number of selections
            if (currentResortCount === 1) {

                $('.js-content-resorts').html('Resort');
            }
            else {

                $('.js-content-resorts').html('Resorts');
            }

            // Determine which label to display for the responsive resort counter section
            if (currentResortCount > 0) {

                $('.js-header-label').hide();
                $('.js-resort-counter').show();
            }
            else {

                $('.js-header-label').show();
                $('.js-resort-counter').hide();
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    updateMetaData
        // PARAMETERS:  metaTitle (META Title for the page)
        //              metaDescription (META Description for the page)
        //              metaCatalogueTag (Correlates to a Canonical Link, or a Robots No Follow META Tag that the page needs to use)
        // DESCRIPTION: This function handles updating the relevent META data for the page on each successful AJAX page state update with new search results
        // **************************************************************************************************************
        var updateMetaData = function(metaTitle, metaDescription, metaCatalogueTag) {

            // Replace the META Title
            $('title').remove();
            $('head').append(metaTitle);

            // Replace the META Description
            $('meta[name=description]').remove();
            $('head').append(metaDescription);

            // Remove any potentially existing Canonical Link
            if ($('link[rel="canonical"]').length) {

                $('link[rel="canonical"]').remove();
            }

            // Remove any potentially existing Robots No Follow META Tag
            if ($('meta[name=robots]').length) {

                $('meta[name=robots]').remove();
            }

            // Replace the META Catalogue Tag
            $('head').append(metaCatalogueTag);
        };

        // **************************************************************************************************************
        // FUNCTION:    updateBackToTopControl
        // PARAMETERS:  none
        // DESCRIPTION: This function handles updating the "Back to Top" button to show or hide depending on how many resorts are being displayed
        // **************************************************************************************************************
        var updateBackToTopControl = function() {

            if (currentResortCount < 10) {

                $('.js-back-to-top').hide();
            }
            else {

                $('.js-back-to-top').show();
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    activateResultScroll
        // PARAMETERS:  none
        // DESCRIPTION: This function handles the activating the resort result listing scroll to top feature
        // **************************************************************************************************************
        var activateResultScroll = function() {

            if (listScrollingEnabled) {

                $('html, body').animate({
                    scrollTop: $('.site-main-container').offset().top
                }, 300);
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    lazyLoadImages
        // PARAMETERS:  none
        // DESCRIPTION: This function handles activating the lazy loader for resort images
        // **************************************************************************************************************
        var lazyLoadImages = function() {

            $('.js-lazy-resort-image').Lazy({
                autoDestroy: true,
                visibleOnly: false,
                threshold: 1000,
                placeholder: "data:image/jpeg;base64,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"
            });
        };

        // **************************************************************************************************************
        // FUNCTION:    highlightMatches
        // PARAMETERS:  label (the text that is subject to being highlighted)
        //              searchCriteria (the criteria to highlight inside of the label text)
        // DESCRIPTION: This function handles highlighting matching search criteria (case-insensitive) inside of other text content
        // **************************************************************************************************************
        var highlightMatches = function(label, searchCriteria) {

            var regex = new RegExp(searchCriteria, 'gi');

            var formattedValue = label.replace(regex, function(match) {
                return '<span class="character-match">' + match + '</span>';
            });

            return formattedValue;
        };

        // **************************************************************************************************************
        // FUNCTION:    removeDuplicates
        // PARAMETERS:  criteriaArray (the array to have duplicate items removed)
        // DESCRIPTION: This function handles removing duplicates from an array
        // **************************************************************************************************************
        var removeDuplicates = function(criteriaArray) {

            var returnArray = criteriaArray.filter(function(elem, index, self) {
                return index === self.indexOf(elem);
            });

            return returnArray;
        };

        // **************************************************************************************************************
        // FUNCTION:    titleCasePhrase
        // PARAMETERS:  phrase (the string to be converted to title case)
        // DESCRIPTION: This function handles splitting a string phrase into individual words and capitalizing the first letter of each word
        // **************************************************************************************************************
        var titleCasePhrase = function(phrase) {

            var returnPhrase = '';
            var originPhrase = phrase.split(' ');

            $.each(originPhrase, function(index, word) {
                returnPhrase = returnPhrase + word.charAt(0).toUpperCase() + word.slice(1);
            });

            return returnPhrase;
        };

        // **************************************************************************************************************
        // FUNCTION:    clearListCardEvents
        // PARAMETERS:  none
        // DESCRIPTION: This function handles removing any existing events (not related to the google map) from the search result list cards
        // **************************************************************************************************************
        var clearListCardEvents = function() {

            $('.resort-list-card').find('.js-available-dates, .js-resort-fees').each(function() {

                $(this).off('click');
            });

            $('.resort-list-card').find('.js-available-dates, .js-local-fees').each(function() {

                $(this).off('click');
            });


        };

        // **************************************************************************************************************
        // FUNCTION:    createListCardEvents
        // PARAMETERS:  none
        // DESCRIPTION: This function handles creating events (not related to the google map) for the search result list cards
        // **************************************************************************************************************
        var createListCardEvents = function() {

            $resortListCard = $('.resort-list-card');

            $resortListCard.find('.js-available-dates').click(function() {

                var resortID = $(this).closest('.resort-list-card').data('resort-id');

                performResortAvailabilitySearch(resortID);
            });

        };

        // **************************************************************************************************************
        // FUNCTION:    updateSearchThrottle
        // PARAMETERS:  data (the search throttle variables)
        // DESCRIPTION: This function handles setting / resetting the search throttle configuration
        // **************************************************************************************************************
        var updateSearchThrottle = function(data) {

            if (data !== 'not-currently-set') {

                isSearchThrottled = (data.enabled === 'Y') ? true : false;
                throttleDelayFrom = parseInt(data.delayFrom);
                throttleDelayTo   = parseInt(data.delayTo);
            }
            else {

                isSearchThrottled = false;
                throttleDelayFrom = 0;
                throttleDelayTo   = 0;
            }
        };

        // **************************************************************************************************************
        // FUNCTION:    getThrottleDelay
        // PARAMETERS:  none
        // DESCRIPTION: This function handles randomly creating a throttle delay based on the current allowable range
        // **************************************************************************************************************
        var getThrottleDelay = function() {

            // Will generate a number between the minimum and maximum (both min / max are inclusive)
            var delay = Math.floor(Math.random() * (throttleDelayTo - throttleDelayFrom + 1) + throttleDelayFrom);

            return delay;
        };

        // **************************************************************************************************************
        // FUNCTION:    displayPerformanceMetrics
        // PARAMETERS:  data (the performance metrics information to display)
        // DESCRIPTION: This function handles logging performance metric information to the console for debugging purposes
        // **************************************************************************************************************
        var displayPerformanceMetrics = function(data) {

            if (enablePerformanceMetrics) {

                console.log('Speed Metrics:', data);
            }
        };

        initializeComponents();
    });
});